import React from 'react'

interface QRCodeWhatsappProps {
  background?: string
  color?: string
  logoBackground?: string
  logoColor?: string
}

export default function QRCodeWhatsapp(props: QRCodeWhatsappProps) {
  return (
    <svg viewBox='0 0 990 990' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M990 0H0V990H990V0Z' fill={props.background} />
      <path
        d='M242 51.5625V44H227.562C225.471 44 223.688 44.7377 222.213 46.213C220.738 47.6883 220 49.4714 220 51.5625V66H242V51.5625Z'
        fill={props.color}
      />
      <path d='M264 44H242V66H264V44Z' fill={props.color} />
      <path
        d='M286 51.5625C286 49.4714 285.262 47.6881 283.787 46.213C282.312 44.7379 280.529 44 278.437 44H264V66H286V51.5625Z'
        fill={props.color}
      />
      <path
        d='M352 58.4375C352 60.529 351.262 62.3119 349.787 63.787C348.312 65.2619 346.529 66 344.437 66H337.562C335.472 66 333.688 65.2619 332.213 63.787C330.738 62.3119 330 60.529 330 58.4375V51.5625C330 49.4716 330.738 47.6883 332.213 46.2132C333.689 44.7379 335.472 44 337.562 44H344.437C346.529 44 348.312 44.7377 349.787 46.213C351.262 47.6885 352 49.4716 352 51.5625V58.4375Z'
        fill={props.color}
      />
      <path
        d='M418 51.5625V44H403.562C401.471 44 399.688 44.7377 398.213 46.213C396.738 47.6883 396 49.4714 396 51.5625V66H418V51.5625Z'
        fill={props.color}
      />
      <path d='M440 44H418V66H440V44Z' fill={props.color} />
      <path d='M462 44H440V66H462V44Z' fill={props.color} />
      <path d='M484 44H462V66H484V44Z' fill={props.color} />
      <path d='M506 44H484V66H506V44Z' fill={props.color} />
      <path
        d='M528 51.5625C528 49.4714 527.262 47.6881 525.787 46.213C524.312 44.7379 522.529 44 520.437 44H506V66H528V51.5625Z'
        fill={props.color}
      />
      <path
        d='M594 51.5625V44H579.562C577.471 44 575.688 44.7377 574.213 46.213C572.738 47.6883 572 49.4714 572 51.5625V66H594V51.5625Z'
        fill={props.color}
      />
      <path
        d='M616 51.5625C616 49.4714 615.262 47.6881 613.787 46.213C612.312 44.7379 610.529 44 608.437 44H594V66H616V51.5625Z'
        fill={props.color}
      />
      <path
        d='M682 51.5625C682 49.4714 681.262 47.6881 679.787 46.213C678.312 44.7379 676.529 44 674.437 44H667.562C665.471 44 663.688 44.7377 662.213 46.213C660.738 47.6883 660 49.4714 660 51.5625V58.4375C660 58.5521 660.014 58.7242 660.043 58.9532H660V66H682V58.9532H681.957C681.986 58.7242 682 58.5523 682 58.4375V51.5625Z'
        fill={props.color}
      />
      <path
        d='M770 58.4375C770 60.529 769.262 62.3119 767.787 63.787C766.312 65.2619 764.529 66 762.437 66H755.562C753.472 66 751.688 65.2619 750.213 63.787C748.738 62.3119 748 60.529 748 58.4375V51.5625C748 49.4716 748.738 47.6883 750.213 46.2132C751.689 44.7379 753.472 44 755.562 44H762.437C764.529 44 766.312 44.7377 767.787 46.213C769.262 47.6885 770 49.4716 770 51.5625V58.4375Z'
        fill={props.color}
      />
      <path d='M242 66H220V88H242V66Z' fill={props.color} />
      <path d='M286 66H264V88H286V66Z' fill={props.color} />
      <path
        d='M308 73.5625C308 71.4714 307.262 69.6881 305.787 68.213C304.312 66.7379 302.529 66 300.437 66H286V88H308V73.5625Z'
        fill={props.color}
      />
      <path
        d='M396 73.5625V66H381.562C379.471 66 377.688 66.7377 376.213 68.213C374.738 69.6883 374 71.4714 374 73.5625V80.4375C374 82.5286 374.738 84.3119 376.213 85.787C377.688 87.2621 379.471 88 381.562 88H396V73.5625Z'
        fill={props.color}
      />
      <path
        d='M418 66H396V88H410.437C412.529 88 414.312 87.2621 415.787 85.787C417.262 84.3119 418 82.5286 418 80.4375V66Z'
        fill={props.color}
      />
      <path
        d='M461.957 73.0468H462V66H440V73.0468H440.043C440.014 73.2761 440 73.4479 440 73.5625V80.4375C440 82.5286 440.738 84.3119 442.213 85.787C443.688 87.2621 445.471 88 447.562 88H454.437C456.529 88 458.312 87.2621 459.787 85.787C461.262 84.3119 462 82.5286 462 80.4375V73.5625C462 73.4479 461.986 73.2761 461.957 73.0468Z'
        fill={props.color}
      />
      <path
        d='M506 66H484V80.4375C484 82.5286 484.738 84.3119 486.213 85.787C487.688 87.2621 489.471 88 491.562 88H506V66Z'
        fill={props.color}
      />
      <path d='M528 66H506V88H528V66Z' fill={props.color} />
      <path
        d='M542.437 66H528V88H542.437C544.529 88 546.312 87.2621 547.787 85.787C549.262 84.3119 550 82.5286 550 80.4375V73.5625C550 71.4714 549.262 69.6881 547.787 68.213C546.312 66.7379 544.529 66 542.437 66Z'
        fill={props.color}
      />
      <path
        d='M594 66H572V80.4375C572 82.5286 572.738 84.3119 574.213 85.787C575.688 87.2621 577.471 88 579.562 88H594V66Z'
        fill={props.color}
      />
      <path d='M616 66H594V88H616V66Z' fill={props.color} />
      <path d='M638 66H616V88H638V66Z' fill={props.color} />
      <path d='M660 66H638V88H660V66Z' fill={props.color} />
      <path d='M682 66H660V88H682V66Z' fill={props.color} />
      <path
        d='M726 80.4375C726 82.529 725.262 84.3119 723.787 85.787C722.312 87.2619 720.529 88 718.437 88H711.562C709.472 88 707.688 87.2619 706.213 85.787C704.738 84.3119 704 82.529 704 80.4375V73.5625C704 71.4716 704.738 69.6883 706.213 68.2132C707.689 66.7379 709.472 66 711.562 66H718.437C720.529 66 722.312 66.7377 723.787 68.213C725.262 69.6885 726 71.4716 726 73.5625V80.4375Z'
        fill={props.color}
      />
      <path
        d='M241.957 95.0468H242V88H220V95.0468H220.043C220.014 95.2761 220 95.4479 220 95.5625V102.437C220 104.529 220.738 106.312 222.213 107.787C223.688 109.262 225.471 110 227.562 110H234.437C236.529 110 238.312 109.262 239.787 107.787C241.262 106.312 242 104.529 242 102.437V95.5625C242 95.4479 241.986 95.2761 241.957 95.0468Z'
        fill={props.color}
      />
      <path d='M286 88H264V110H286V88Z' fill={props.color} />
      <path d='M308 88H286V110H308V88Z' fill={props.color} />
      <path
        d='M322.437 88H308V110H322.437C324.529 110 326.312 109.262 327.787 107.787C329.262 106.312 330 104.529 330 102.437V95.5625C330 93.4714 329.262 91.6881 327.787 90.213C326.312 88.7379 324.529 88 322.437 88Z'
        fill={props.color}
      />
      <path
        d='M440 95.5625C440 93.4714 439.262 91.6881 437.787 90.213C436.312 88.7379 434.529 88 432.437 88H425.562C423.471 88 421.688 88.7377 420.213 90.213C418.738 91.6883 418 93.4714 418 95.5625V102.437C418 102.552 418.014 102.724 418.043 102.953H418V110H440V102.953H439.957C439.986 102.724 440 102.552 440 102.437V95.5625Z'
        fill={props.color}
      />
      <path
        d='M572 102.437C572 104.529 571.262 106.312 569.787 107.787C568.312 109.262 566.529 110 564.437 110H557.562C555.472 110 553.688 109.262 552.213 107.787C550.738 106.312 550 104.529 550 102.437V95.5625C550 93.4716 550.738 91.6883 552.213 90.2132C553.689 88.7379 555.472 88 557.562 88H564.437C566.529 88 568.312 88.7377 569.787 90.213C571.262 91.6885 572 93.4716 572 95.5625V102.437Z'
        fill={props.color}
      />
      <path
        d='M615.957 95.0468H616V88H594V95.0468H594.043C594.014 95.2761 594 95.4479 594 95.5625V102.437C594 104.529 594.738 106.312 596.213 107.787C597.688 109.262 599.471 110 601.562 110H608.437C610.529 110 612.312 109.262 613.787 107.787C615.262 106.312 616 104.529 616 102.437V95.5625C616 95.4479 615.986 95.2761 615.957 95.0468Z'
        fill={props.color}
      />
      <path d='M660 88H638V110H660V88Z' fill={props.color} />
      <path d='M682 88H660V110H682V88Z' fill={props.color} />
      <path
        d='M264 117.562V110H249.562C247.471 110 245.688 110.738 244.213 112.213C242.738 113.688 242 115.471 242 117.562V124.437C242 126.529 242.738 128.312 244.213 129.787C245.688 131.262 247.471 132 249.562 132H264V117.562Z'
        fill={props.color}
      />
      <path d='M286 110H264V132H286V110Z' fill={props.color} />
      <path
        d='M352 117.562V110H337.562C335.471 110 333.688 110.738 332.213 112.213C330.738 113.688 330 115.471 330 117.562V132H352V117.562Z'
        fill={props.color}
      />
      <path
        d='M366.437 110H352V132H366.437C368.529 132 370.312 131.262 371.787 129.787C373.262 128.312 374 126.529 374 124.437V117.562C374 115.471 373.262 113.688 371.787 112.213C370.312 110.738 368.529 110 366.437 110Z'
        fill={props.color}
      />
      <path
        d='M440 110H418V124.437C418 126.529 418.738 128.312 420.213 129.787C421.688 131.262 423.471 132 425.562 132H440V110Z'
        fill={props.color}
      />
      <path d='M462 110H440V132H462V110Z' fill={props.color} />
      <path d='M484 110H462V132H484V110Z' fill={props.color} />
      <path
        d='M506 117.562C506 115.471 505.262 113.688 503.787 112.213C502.312 110.738 500.529 110 498.437 110H484V132H506V117.562Z'
        fill={props.color}
      />
      <path
        d='M550 117.562C550 115.471 549.262 113.688 547.787 112.213C546.312 110.738 544.529 110 542.437 110H535.562C533.471 110 531.688 110.738 530.213 112.213C528.738 113.688 528 115.471 528 117.562V124.437C528 124.552 528.014 124.724 528.043 124.953H528V132H550V124.953H549.957C549.986 124.724 550 124.552 550 124.437V117.562Z'
        fill={props.color}
      />
      <path
        d='M594 124.437C594 126.529 593.262 128.312 591.787 129.787C590.312 131.262 588.529 132 586.437 132H579.562C577.472 132 575.688 131.262 574.213 129.787C572.738 128.312 572 126.529 572 124.437V117.562C572 115.472 572.738 113.688 574.213 112.213C575.689 110.738 577.472 110 579.562 110H586.437C588.529 110 590.312 110.738 591.787 112.213C593.262 113.689 594 115.472 594 117.562V124.437Z'
        fill={props.color}
      />
      <path
        d='M638 117.562V110H623.562C621.471 110 619.688 110.738 618.213 112.213C616.738 113.688 616 115.471 616 117.562V124.437C616 126.529 616.738 128.312 618.213 129.787C619.688 131.262 621.471 132 623.562 132H638V117.562Z'
        fill={props.color}
      />
      <path d='M660 110H638V132H660V110Z' fill={props.color} />
      <path d='M682 110H660V132H682V110Z' fill={props.color} />
      <path
        d='M726 124.437C726 126.529 725.262 128.312 723.787 129.787C722.312 131.262 720.529 132 718.437 132H711.562C709.472 132 707.688 131.262 706.213 129.787C704.738 128.312 704 126.529 704 124.437V117.562C704 115.472 704.738 113.688 706.213 112.213C707.689 110.738 709.472 110 711.562 110H718.437C720.529 110 722.312 110.738 723.787 112.213C725.262 113.689 726 115.472 726 117.562V124.437Z'
        fill={props.color}
      />
      <path
        d='M770 124.437C770 126.529 769.262 128.312 767.787 129.787C766.312 131.262 764.529 132 762.437 132H755.562C753.472 132 751.688 131.262 750.213 129.787C748.738 128.312 748 126.529 748 124.437V117.562C748 115.472 748.738 113.688 750.213 112.213C751.689 110.738 753.472 110 755.562 110H762.437C764.529 110 766.312 110.738 767.787 112.213C769.262 113.689 770 115.472 770 117.562V124.437Z'
        fill={props.color}
      />
      <path d='M286 132H264V154H286V132Z' fill={props.color} />
      <path
        d='M308 139.562C308 137.471 307.262 135.688 305.787 134.213C304.312 132.738 302.529 132 300.437 132H286V154H308V139.562Z'
        fill={props.color}
      />
      <path d='M352 132H330V154H352V132Z' fill={props.color} />
      <path
        d='M418 139.562C418 137.471 417.262 135.688 415.787 134.213C414.312 132.738 412.529 132 410.437 132H403.562C401.471 132 399.688 132.738 398.213 134.213C396.738 135.688 396 137.471 396 139.562V146.437C396 146.552 396.014 146.724 396.043 146.953H396V154H418V146.953H417.957C417.986 146.724 418 146.552 418 146.437V139.562Z'
        fill={props.color}
      />
      <path
        d='M505.957 139.047H506V132H484V139.047H484.043C484.014 139.276 484 139.448 484 139.562V146.437C484 148.529 484.738 150.312 486.213 151.787C487.688 153.262 489.471 154 491.562 154H498.437C500.529 154 502.312 153.262 503.787 151.787C505.262 150.312 506 148.529 506 146.437V139.562C506 139.448 505.986 139.276 505.957 139.047Z'
        fill={props.color}
      />
      <path d='M550 132H528V154H550V132Z' fill={props.color} />
      <path d='M682 132H660V154H682V132Z' fill={props.color} />
      <path
        d='M748 146.437C748 148.529 747.262 150.312 745.787 151.787C744.312 153.262 742.529 154 740.437 154H733.562C731.472 154 729.688 153.262 728.213 151.787C726.738 150.312 726 148.529 726 146.437V139.562C726 137.472 726.738 135.688 728.213 134.213C729.689 132.738 731.472 132 733.562 132H740.437C742.529 132 744.312 132.738 745.787 134.213C747.262 135.689 748 137.472 748 139.562V146.437Z'
        fill={props.color}
      />
      <path
        d='M242 161.562V154H227.562C225.471 154 223.688 154.738 222.213 156.213C220.738 157.688 220 159.471 220 161.562V176H242V161.562Z'
        fill={props.color}
      />
      <path d='M264 154H242V176H264V154Z' fill={props.color} />
      <path d='M286 154H264V176H286V154Z' fill={props.color} />
      <path d='M308 154H286V176H308V154Z' fill={props.color} />
      <path d='M330 154H308V176H330V154Z' fill={props.color} />
      <path d='M352 154H330V176H352V154Z' fill={props.color} />
      <path d='M374 154H352V176H374V154Z' fill={props.color} />
      <path d='M396 154H374V176H396V154Z' fill={props.color} />
      <path d='M418 154H396V176H418V154Z' fill={props.color} />
      <path
        d='M432.437 154H418V176H432.437C434.529 176 436.312 175.262 437.787 173.787C439.262 172.312 440 170.529 440 168.437V161.562C440 159.471 439.262 157.688 437.787 156.213C436.312 154.738 434.529 154 432.437 154Z'
        fill={props.color}
      />
      <path d='M550 154H528V176H550V154Z' fill={props.color} />
      <path
        d='M594 161.562C594 159.471 593.262 157.688 591.787 156.213C590.312 154.738 588.529 154 586.437 154H579.562C577.471 154 575.688 154.738 574.213 156.213C572.738 157.688 572 159.471 572 161.562V168.437C572 168.552 572.014 168.724 572.043 168.953H572V176H594V168.953H593.957C593.986 168.724 594 168.552 594 168.437V161.562Z'
        fill={props.color}
      />
      <path
        d='M660 161.562V154H645.562C643.471 154 641.688 154.738 640.213 156.213C638.738 157.688 638 159.471 638 161.562V168.437C638 170.529 638.738 172.312 640.213 173.787C641.688 175.262 643.471 176 645.562 176H660V161.562Z'
        fill={props.color}
      />
      <path d='M682 154H660V176H682V154Z' fill={props.color} />
      <path
        d='M696.437 154H682V176H696.437C698.529 176 700.312 175.262 701.787 173.787C703.262 172.312 704 170.529 704 168.437V161.562C704 159.471 703.262 157.688 701.787 156.213C700.312 154.738 698.529 154 696.437 154Z'
        fill={props.color}
      />
      <path d='M242 176H220V198H242V176Z' fill={props.color} />
      <path
        d='M285.957 183.047H286V176H264V183.047H264.043C264.014 183.276 264 183.448 264 183.562V190.437C264 192.529 264.738 194.312 266.213 195.787C267.688 197.262 269.471 198 271.562 198H278.437C280.529 198 282.312 197.262 283.787 195.787C285.262 194.312 286 192.529 286 190.437V183.562C286 183.448 285.986 183.276 285.957 183.047Z'
        fill={props.color}
      />
      <path d='M330 176H308V198H330V176Z' fill={props.color} />
      <path
        d='M373.957 183.047H374V176H352V183.047H352.043C352.014 183.276 352 183.448 352 183.562V190.437C352 192.529 352.738 194.312 354.213 195.787C355.688 197.262 357.471 198 359.562 198H366.437C368.529 198 370.312 197.262 371.787 195.787C373.262 194.312 374 192.529 374 190.437V183.562C374 183.448 373.986 183.276 373.957 183.047Z'
        fill={props.color}
      />
      <path d='M418 176H396V198H418V176Z' fill={props.color} />
      <path
        d='M462 183.562C462 181.471 461.262 179.688 459.787 178.213C458.312 176.738 456.529 176 454.437 176H447.562C445.471 176 443.688 176.738 442.213 178.213C440.738 179.688 440 181.471 440 183.562V190.437C440 190.552 440.014 190.724 440.043 190.953H440V198H462V190.953H461.957C461.986 190.724 462 190.552 462 190.437V183.562Z'
        fill={props.color}
      />
      <path
        d='M506 190.437C506 192.529 505.262 194.312 503.787 195.787C502.312 197.262 500.529 198 498.437 198H491.562C489.472 198 487.688 197.262 486.213 195.787C484.738 194.312 484 192.529 484 190.437V183.562C484 181.472 484.738 179.688 486.213 178.213C487.689 176.738 489.472 176 491.562 176H498.437C500.529 176 502.312 176.738 503.787 178.213C505.262 179.689 506 181.472 506 183.562V190.437Z'
        fill={props.color}
      />
      <path d='M550 176H528V198H550V176Z' fill={props.color} />
      <path d='M594 176H572V198H594V176Z' fill={props.color} />
      <path
        d='M638 183.562C638 181.471 637.262 179.688 635.787 178.213C634.312 176.738 632.529 176 630.437 176H623.562C621.471 176 619.688 176.738 618.213 178.213C616.738 179.688 616 181.471 616 183.562V190.437C616 190.552 616.014 190.724 616.043 190.953H616V198H638V190.953H637.957C637.986 190.724 638 190.552 638 190.437V183.562Z'
        fill={props.color}
      />
      <path d='M682 176H660V198H682V176Z' fill={props.color} />
      <path
        d='M726 190.437C726 192.529 725.262 194.312 723.787 195.787C722.312 197.262 720.529 198 718.437 198H711.562C709.472 198 707.688 197.262 706.213 195.787C704.738 194.312 704 192.529 704 190.437V183.562C704 181.472 704.738 179.688 706.213 178.213C707.689 176.738 709.472 176 711.562 176H718.437C720.529 176 722.312 176.738 723.787 178.213C725.262 179.689 726 181.472 726 183.562V190.437Z'
        fill={props.color}
      />
      <path
        d='M770 183.562C770 181.471 769.262 179.688 767.787 178.213C766.312 176.738 764.529 176 762.437 176H755.562C753.471 176 751.688 176.738 750.213 178.213C748.738 179.688 748 181.471 748 183.562V190.437C748 190.552 748.014 190.724 748.043 190.953H748V198H770V190.953H769.957C769.986 190.724 770 190.552 770 190.437V183.562Z'
        fill={props.color}
      />
      <path d='M242 198H220V220H242V198Z' fill={props.color} />
      <path d='M330 198H308V220H330V198Z' fill={props.color} />
      <path
        d='M396 205.562V198H381.562C379.471 198 377.688 198.738 376.213 200.213C374.738 201.688 374 203.471 374 205.562V212.437C374 214.529 374.738 216.312 376.213 217.787C377.688 219.262 379.471 220 381.562 220H396V205.562Z'
        fill={props.color}
      />
      <path
        d='M418 198H396V220H410.437C412.529 220 414.312 219.262 415.787 217.787C417.262 216.312 418 214.529 418 212.437V198Z'
        fill={props.color}
      />
      <path
        d='M461.957 205.047H462V198H440V205.047H440.043C440.014 205.276 440 205.448 440 205.562V212.437C440 214.529 440.738 216.312 442.213 217.787C443.688 219.262 445.471 220 447.562 220H454.437C456.529 220 458.312 219.262 459.787 217.787C461.262 216.312 462 214.529 462 212.437V205.562C462 205.448 461.986 205.276 461.957 205.047Z'
        fill={props.color}
      />
      <path
        d='M549.957 205.047H550V198H528V205.047H528.043C528.014 205.276 528 205.448 528 205.562V212.437C528 214.529 528.738 216.312 530.213 217.787C531.688 219.262 533.471 220 535.562 220H542.437C544.529 220 546.312 219.262 547.787 217.787C549.262 216.312 550 214.529 550 212.437V205.562C550 205.448 549.986 205.276 549.957 205.047Z'
        fill={props.color}
      />
      <path d='M594 198H572V220H594V198Z' fill={props.color} />
      <path d='M638 198H616V220H638V198Z' fill={props.color} />
      <path
        d='M681.957 205.047H682V198H660V205.047H660.043C660.014 205.276 660 205.448 660 205.562V212.437C660 214.529 660.738 216.312 662.213 217.787C663.688 219.262 665.471 220 667.562 220H674.437C676.529 220 678.312 219.262 679.787 217.787C681.262 216.312 682 214.529 682 212.437V205.562C682 205.448 681.986 205.276 681.957 205.047Z'
        fill={props.color}
      />
      <path d='M770 198H748V220H770V198Z' fill={props.color} />
      <path
        d='M110 227.562V220H95.5625C93.4714 220 91.6881 220.738 90.213 222.213C88.7379 223.688 88 225.471 88 227.562V234.437C88 236.529 88.7377 238.312 90.213 239.787C91.6883 241.262 93.4714 242 95.5625 242H110V227.562Z'
        fill={props.color}
      />
      <path d='M132 220H110V242H132V220Z' fill={props.color} />
      <path
        d='M146.437 220H132V242H146.437C148.529 242 150.312 241.262 151.787 239.787C153.262 238.312 154 236.529 154 234.437V227.562C154 225.471 153.262 223.688 151.787 222.213C150.312 220.738 148.529 220 146.437 220Z'
        fill={props.color}
      />
      <path
        d='M198 234.437C198 236.529 197.262 238.312 195.787 239.787C194.312 241.262 192.529 242 190.437 242H183.562C181.472 242 179.688 241.262 178.213 239.787C176.738 238.312 176 236.529 176 234.437V227.562C176 225.472 176.738 223.688 178.213 222.213C179.689 220.738 181.472 220 183.562 220H190.437C192.529 220 194.312 220.738 195.787 222.213C197.262 223.689 198 225.472 198 227.562V234.437Z'
        fill={props.color}
      />
      <path d='M242 220H220V242H242V220Z' fill={props.color} />
      <path
        d='M264 227.562C264 225.471 263.262 223.688 261.787 222.213C260.312 220.738 258.529 220 256.437 220H242V242H264V227.562Z'
        fill={props.color}
      />
      <path
        d='M329.957 227.047H330V220H308V227.047H308.043C308.014 227.276 308 227.448 308 227.562V234.437C308 236.529 308.738 238.312 310.213 239.787C311.688 241.262 313.471 242 315.562 242H322.437C324.529 242 326.312 241.262 327.787 239.787C329.262 238.312 330 236.529 330 234.437V227.562C330 227.448 329.986 227.276 329.957 227.047Z'
        fill={props.color}
      />
      <path
        d='M440 227.562C440 225.471 439.262 223.688 437.787 222.213C436.312 220.738 434.529 220 432.437 220H425.562C423.471 220 421.688 220.738 420.213 222.213C418.738 223.688 418 225.471 418 227.562V234.437C418 234.552 418.014 234.724 418.043 234.953H418V242H440V234.953H439.957C439.986 234.724 440 234.552 440 234.437V227.562Z'
        fill={props.color}
      />
      <path
        d='M484 227.562V220H469.562C467.471 220 465.688 220.738 464.213 222.213C462.738 223.688 462 225.471 462 227.562V242H484V227.562Z'
        fill={props.color}
      />
      <path d='M506 220H484V242H506V220Z' fill={props.color} />
      <path
        d='M520.437 220H506V242H520.437C522.529 242 524.312 241.262 525.787 239.787C527.262 238.312 528 236.529 528 234.437V227.562C528 225.471 527.262 223.688 525.787 222.213C524.312 220.738 522.529 220 520.437 220Z'
        fill={props.color}
      />
      <path
        d='M572 227.562V220H557.562C555.471 220 553.688 220.738 552.213 222.213C550.738 223.688 550 225.471 550 227.562V234.437C550 236.529 550.738 238.312 552.213 239.787C553.688 241.262 555.471 242 557.562 242H572V227.562Z'
        fill={props.color}
      />
      <path d='M594 220H572V242H594V220Z' fill={props.color} />
      <path d='M616 220H594V242H616V220Z' fill={props.color} />
      <path
        d='M638 220H616V242H630.437C632.529 242 634.312 241.262 635.787 239.787C637.262 238.312 638 236.529 638 234.437V220Z'
        fill={props.color}
      />
      <path
        d='M704 234.437C704 236.529 703.262 238.312 701.787 239.787C700.312 241.262 698.529 242 696.437 242H689.562C687.472 242 685.688 241.262 684.213 239.787C682.738 238.312 682 236.529 682 234.437V227.562C682 225.472 682.738 223.688 684.213 222.213C685.689 220.738 687.472 220 689.562 220H696.437C698.529 220 700.312 220.738 701.787 222.213C703.262 223.689 704 225.472 704 227.562V234.437Z'
        fill={props.color}
      />
      <path d='M770 220H748V242H770V220Z' fill={props.color} />
      <path d='M792 220H770V242H792V220Z' fill={props.color} />
      <path d='M814 220H792V242H814V220Z' fill={props.color} />
      <path
        d='M836 227.562C836 225.471 835.262 223.688 833.787 222.213C832.312 220.738 830.529 220 828.437 220H814V242H836V227.562Z'
        fill={props.color}
      />
      <path
        d='M902 227.562V220H887.562C885.471 220 883.688 220.738 882.213 222.213C880.738 223.688 880 225.471 880 227.562V242H902V227.562Z'
        fill={props.color}
      />
      <path d='M924 220H902V242H924V220Z' fill={props.color} />
      <path
        d='M938.437 220H924V242H938.437C940.529 242 942.312 241.262 943.787 239.787C945.262 238.312 946 236.529 946 234.437V227.562C946 225.471 945.262 223.688 943.787 222.213C942.312 220.738 940.529 220 938.437 220Z'
        fill={props.color}
      />
      <path
        d='M220 249.562V242H205.562C203.471 242 201.688 242.738 200.213 244.213C198.738 245.688 198 247.471 198 249.562V264H220V249.562Z'
        fill={props.color}
      />
      <path d='M242 242H220V264H242V242Z' fill={props.color} />
      <path d='M264 242H242V264H264V242Z' fill={props.color} />
      <path
        d='M286 249.562C286 247.471 285.262 245.688 283.787 244.213C282.312 242.738 280.529 242 278.437 242H264V264H286V249.562Z'
        fill={props.color}
      />
      <path
        d='M352 249.562V242H337.562C335.471 242 333.688 242.738 332.213 244.213C330.738 245.688 330 247.471 330 249.562V264H352V249.562Z'
        fill={props.color}
      />
      <path
        d='M374 249.562C374 247.471 373.262 245.688 371.787 244.213C370.312 242.738 368.529 242 366.437 242H352V264H374V249.562Z'
        fill={props.color}
      />
      <path
        d='M418 249.562V242H403.562C401.471 242 399.688 242.738 398.213 244.213C396.738 245.688 396 247.471 396 249.562V264H418V249.562Z'
        fill={props.color}
      />
      <path
        d='M440 242H418V264H432.437C434.529 264 436.312 263.262 437.787 261.787C439.262 260.312 440 258.529 440 256.437V242Z'
        fill={props.color}
      />
      <path
        d='M484 242H462V256.437C462 258.529 462.738 260.312 464.213 261.787C465.688 263.262 467.471 264 469.562 264H484V242Z'
        fill={props.color}
      />
      <path
        d='M506 242H484V264H498.437C500.529 264 502.312 263.262 503.787 261.787C505.262 260.312 506 258.529 506 256.437V242Z'
        fill={props.color}
      />
      <path
        d='M726 249.562V242H711.562C709.471 242 707.688 242.738 706.213 244.213C704.738 245.688 704 247.471 704 249.562V256.437C704 258.529 704.738 260.312 706.213 261.787C707.688 263.262 709.471 264 711.562 264H726V249.562Z'
        fill={props.color}
      />
      <path d='M748 242H726V264H748V242Z' fill={props.color} />
      <path d='M770 242H748V264H770V242Z' fill={props.color} />
      <path d='M792 242H770V264H792V242Z' fill={props.color} />
      <path d='M814 242H792V264H814V242Z' fill={props.color} />
      <path d='M836 242H814V264H836V242Z' fill={props.color} />
      <path
        d='M850.437 242H836V264H850.437C852.529 264 854.312 263.262 855.787 261.787C857.262 260.312 858 258.529 858 256.437V249.562C858 247.471 857.262 245.688 855.787 244.213C854.312 242.738 852.529 242 850.437 242Z'
        fill={props.color}
      />
      <path
        d='M902 242H880V256.437C880 258.529 880.738 260.312 882.213 261.787C883.688 263.262 885.471 264 887.562 264H902V242Z'
        fill={props.color}
      />
      <path d='M924 242H902V264H924V242Z' fill={props.color} />
      <path
        d='M132 271.562V264H117.562C115.471 264 113.688 264.738 112.213 266.213C110.738 267.688 110 269.471 110 271.562V286H132V271.562Z'
        fill={props.color}
      />
      <path
        d='M154 271.562C154 269.471 153.262 267.688 151.787 266.213C150.312 264.738 148.529 264 146.437 264H132V286H154V271.562Z'
        fill={props.color}
      />
      <path
        d='M198 271.562V264H183.562C181.471 264 179.688 264.738 178.213 266.213C176.738 267.688 176 269.471 176 271.562V278.437C176 280.529 176.738 282.312 178.213 283.787C179.688 285.262 181.471 286 183.562 286H198V271.562Z'
        fill={props.color}
      />
      <path d='M220 264H198V286H220V264Z' fill={props.color} />
      <path
        d='M242 264H220V286H234.437C236.529 286 238.312 285.262 239.787 283.787C241.262 282.312 242 280.529 242 278.437V264Z'
        fill={props.color}
      />
      <path
        d='M286 264H264V278.437C264 280.529 264.738 282.312 266.213 283.787C267.688 285.262 269.471 286 271.562 286H286V264Z'
        fill={props.color}
      />
      <path d='M308 264H286V286H308V264Z' fill={props.color} />
      <path d='M330 264H308V286H330V264Z' fill={props.color} />
      <path d='M352 264H330V286H352V264Z' fill={props.color} />
      <path d='M374 264H352V286H374V264Z' fill={props.color} />
      <path d='M418 264H396V286H418V264Z' fill={props.color} />
      <path
        d='M528 271.562V264H513.562C511.471 264 509.688 264.738 508.213 266.213C506.738 267.688 506 269.471 506 271.562V286H528V271.562Z'
        fill={props.color}
      />
      <path
        d='M542.437 264H528V286H542.437C544.529 286 546.312 285.262 547.787 283.787C549.262 282.312 550 280.529 550 278.437V271.562C550 269.471 549.262 267.688 547.787 266.213C546.312 264.738 544.529 264 542.437 264Z'
        fill={props.color}
      />
      <path
        d='M594 278.437C594 280.529 593.262 282.312 591.787 283.787C590.312 285.262 588.529 286 586.437 286H579.562C577.472 286 575.688 285.262 574.213 283.787C572.738 282.312 572 280.529 572 278.437V271.562C572 269.472 572.738 267.688 574.213 266.213C575.689 264.738 577.472 264 579.562 264H586.437C588.529 264 590.312 264.738 591.787 266.213C593.262 267.689 594 269.472 594 271.562V278.437Z'
        fill={props.color}
      />
      <path
        d='M638 271.562V264H623.562C621.471 264 619.688 264.738 618.213 266.213C616.738 267.688 616 269.471 616 271.562V286H638V271.562Z'
        fill={props.color}
      />
      <path d='M660 264H638V286H660V264Z' fill={props.color} />
      <path d='M682 264H660V286H682V264Z' fill={props.color} />
      <path
        d='M696.437 264H682V286H696.437C698.529 286 700.312 285.262 701.787 283.787C703.262 282.312 704 280.529 704 278.437V271.562C704 269.471 703.262 267.688 701.787 266.213C700.312 264.738 698.529 264 696.437 264Z'
        fill={props.color}
      />
      <path d='M770 264H748V286H770V264Z' fill={props.color} />
      <path
        d='M792 264H770V286H784.437C786.529 286 788.312 285.262 789.787 283.787C791.262 282.312 792 280.529 792 278.437V264Z'
        fill={props.color}
      />
      <path d='M836 264H814V286H836V264Z' fill={props.color} />
      <path
        d='M923.957 271.047H924V264H902V271.047H902.043C902.014 271.276 902 271.448 902 271.562V278.437C902 280.529 902.738 282.312 904.213 283.787C905.688 285.262 907.471 286 909.562 286H916.437C918.529 286 920.312 285.262 921.787 283.787C923.262 282.312 924 280.529 924 278.437V271.562C924 271.448 923.986 271.276 923.957 271.047Z'
        fill={props.color}
      />
      <path
        d='M66 293.562V286H51.5625C49.4714 286 47.6881 286.738 46.213 288.213C44.7379 289.688 44 291.471 44 293.562V308H66V293.562Z'
        fill={props.color}
      />
      <path
        d='M80.4375 286H66V308H80.4375C82.5286 308 84.3119 307.262 85.787 305.787C87.2621 304.312 88 302.529 88 300.437V293.562C88 291.471 87.2621 289.688 85.787 288.213C84.3119 286.738 82.5286 286 80.4375 286Z'
        fill={props.color}
      />
      <path
        d='M132 286H110V300.437C110 302.529 110.738 304.312 112.213 305.787C113.688 307.262 115.471 308 117.562 308H132V286Z'
        fill={props.color}
      />
      <path d='M154 286H132V308H154V286Z' fill={props.color} />
      <path
        d='M176 293.562C176 291.471 175.262 289.688 173.787 288.213C172.312 286.738 170.529 286 168.437 286H154V308H176V293.562Z'
        fill={props.color}
      />
      <path
        d='M264 300.437C264 302.529 263.262 304.312 261.787 305.787C260.312 307.262 258.529 308 256.437 308H249.562C247.472 308 245.688 307.262 244.213 305.787C242.738 304.312 242 302.529 242 300.437V293.562C242 291.472 242.738 289.688 244.213 288.213C245.689 286.738 247.472 286 249.562 286H256.437C258.529 286 260.312 286.738 261.787 288.213C263.262 289.689 264 291.472 264 293.562V300.437Z'
        fill={props.color}
      />
      <path d='M330 286H308V308H330V286Z' fill={props.color} />
      <path d='M374 286H352V308H374V286Z' fill={props.color} />
      <path
        d='M418 286H396V300.437C396 302.529 396.738 304.312 398.213 305.787C399.688 307.262 401.471 308 403.562 308H418V286Z'
        fill={props.color}
      />
      <path
        d='M440 293.562C440 291.471 439.262 289.688 437.787 288.213C436.312 286.738 434.529 286 432.437 286H418V308H440V293.562Z'
        fill={props.color}
      />
      <path
        d='M527.957 293.047H528V286H506V293.047H506.043C506.014 293.276 506 293.448 506 293.562V300.437C506 302.529 506.738 304.312 508.213 305.787C509.688 307.262 511.471 308 513.562 308H520.437C522.529 308 524.312 307.262 525.787 305.787C527.262 304.312 528 302.529 528 300.437V293.562C528 293.448 527.986 293.276 527.957 293.047Z'
        fill={props.color}
      />
      <path d='M638 286H616V308H638V286Z' fill={props.color} />
      <path d='M660 286H638V308H660V286Z' fill={props.color} />
      <path d='M682 286H660V308H682V286Z' fill={props.color} />
      <path
        d='M748 293.562V286H733.562C731.471 286 729.688 286.738 728.213 288.213C726.738 289.688 726 291.471 726 293.562V308H748V293.562Z'
        fill={props.color}
      />
      <path
        d='M770 286H748V308H762.437C764.529 308 766.312 307.262 767.787 305.787C769.262 304.312 770 302.529 770 300.437V286Z'
        fill={props.color}
      />
      <path d='M836 286H814V308H836V286Z' fill={props.color} />
      <path
        d='M880 293.562C880 291.471 879.262 289.688 877.787 288.213C876.312 286.738 874.529 286 872.437 286H865.562C863.471 286 861.688 286.738 860.213 288.213C858.738 289.688 858 291.471 858 293.562V300.437C858 300.552 858.014 300.724 858.043 300.953H858V308H880V300.953H879.957C879.986 300.724 880 300.552 880 300.437V293.562Z'
        fill={props.color}
      />
      <path
        d='M65.9571 315.047H66V308H44V315.047H44.0429C44.0143 315.276 44 315.448 44 315.562V322.437C44 324.529 44.7377 326.312 46.213 327.787C47.6883 329.262 49.4714 330 51.5625 330H58.4375C60.5286 330 62.3119 329.262 63.787 327.787C65.2621 326.312 66 324.529 66 322.437V315.562C66 315.448 65.9861 315.276 65.9571 315.047Z'
        fill={props.color}
      />
      <path
        d='M110 322.437C110 324.529 109.262 326.312 107.787 327.787C106.312 329.262 104.529 330 102.437 330H95.5625C93.4716 330 91.6883 329.262 90.2132 327.787C88.7379 326.312 88 324.529 88 322.437V315.562C88 313.472 88.7377 311.688 90.213 310.213C91.6885 308.738 93.4716 308 95.5625 308H102.437C104.529 308 106.312 308.738 107.787 310.213C109.262 311.689 110 313.472 110 315.562V322.437Z'
        fill={props.color}
      />
      <path
        d='M176 308H154V322.437C154 324.529 154.738 326.312 156.213 327.787C157.688 329.262 159.471 330 161.562 330H176V308Z'
        fill={props.color}
      />
      <path
        d='M190.437 308H176V330H190.437C192.529 330 194.312 329.262 195.787 327.787C197.262 326.312 198 324.529 198 322.437V315.562C198 313.471 197.262 311.688 195.787 310.213C194.312 308.738 192.529 308 190.437 308Z'
        fill={props.color}
      />
      <path
        d='M308 315.562V308H293.562C291.471 308 289.688 308.738 288.213 310.213C286.738 311.688 286 313.471 286 315.562V330H308V315.562Z'
        fill={props.color}
      />
      <path d='M330 308H308V330H330V308Z' fill={props.color} />
      <path d='M374 308H352V330H374V308Z' fill={props.color} />
      <path d='M440 308H418V330H440V308Z' fill={props.color} />
      <path
        d='M506 315.562C506 313.471 505.262 311.688 503.787 310.213C502.312 308.738 500.529 308 498.437 308H491.562C489.471 308 487.688 308.738 486.213 310.213C484.738 311.688 484 313.471 484 315.562V322.437C484 322.552 484.014 322.724 484.043 322.953H484V330H506V322.953H505.957C505.986 322.724 506 322.552 506 322.437V315.562Z'
        fill={props.color}
      />
      <path
        d='M572 315.562V308H557.562C555.471 308 553.688 308.738 552.213 310.213C550.738 311.688 550 313.471 550 315.562V322.437C550 324.529 550.738 326.312 552.213 327.787C553.688 329.262 555.471 330 557.562 330H572V315.562Z'
        fill={props.color}
      />
      <path
        d='M586.437 308H572V330H586.437C588.529 330 590.312 329.262 591.787 327.787C593.262 326.312 594 324.529 594 322.437V315.562C594 313.471 593.262 311.688 591.787 310.213C590.312 308.738 588.529 308 586.437 308Z'
        fill={props.color}
      />
      <path d='M638 308H616V330H638V308Z' fill={props.color} />
      <path d='M660 308H638V330H660V308Z' fill={props.color} />
      <path d='M682 308H660V330H682V308Z' fill={props.color} />
      <path d='M704 308H682V330H704V308Z' fill={props.color} />
      <path d='M726 308H704V330H726V308Z' fill={props.color} />
      <path
        d='M748 308H726V330H740.437C742.529 330 744.312 329.262 745.787 327.787C747.262 326.312 748 324.529 748 322.437V308Z'
        fill={props.color}
      />
      <path
        d='M792 322.437C792 324.529 791.262 326.312 789.787 327.787C788.312 329.262 786.529 330 784.437 330H777.562C775.472 330 773.688 329.262 772.213 327.787C770.738 326.312 770 324.529 770 322.437V315.562C770 313.472 770.738 311.688 772.213 310.213C773.689 308.738 775.472 308 777.562 308H784.437C786.529 308 788.312 308.738 789.787 310.213C791.262 311.689 792 313.472 792 315.562V322.437Z'
        fill={props.color}
      />
      <path
        d='M835.957 315.047H836V308H814V315.047H814.043C814.014 315.276 814 315.448 814 315.562V322.437C814 324.529 814.738 326.312 816.213 327.787C817.688 329.262 819.471 330 821.562 330H828.437C830.529 330 832.312 329.262 833.787 327.787C835.262 326.312 836 324.529 836 322.437V315.562C836 315.448 835.986 315.276 835.957 315.047Z'
        fill={props.color}
      />
      <path d='M880 308H858V330H880V308Z' fill={props.color} />
      <path d='M902 308H880V330H902V308Z' fill={props.color} />
      <path d='M924 308H902V330H924V308Z' fill={props.color} />
      <path
        d='M946 315.562C946 313.471 945.262 311.688 943.787 310.213C942.312 308.738 940.529 308 938.437 308H924V330H946V315.562Z'
        fill={props.color}
      />
      <path
        d='M88 344.437C88 346.529 87.2619 348.312 85.787 349.787C84.3119 351.262 82.529 352 80.4375 352H73.5625C71.4716 352 69.6883 351.262 68.2132 349.787C66.7379 348.312 66 346.529 66 344.437V337.562C66 335.472 66.7377 333.688 68.213 332.213C69.6885 330.738 71.4716 330 73.5625 330H80.4375C82.5293 330 84.3124 330.738 85.787 332.213C87.2621 333.689 88 335.472 88 337.562V344.437Z'
        fill={props.color}
      />
      <path
        d='M132 337.562C132 335.471 131.262 333.688 129.787 332.213C128.312 330.738 126.529 330 124.437 330H117.562C115.471 330 113.688 330.738 112.213 332.213C110.738 333.688 110 335.471 110 337.562V344.437C110 344.552 110.014 344.724 110.043 344.953H110V352H132V344.953H131.957C131.986 344.724 132 344.552 132 344.437V337.562Z'
        fill={props.color}
      />
      <path
        d='M242 337.562C242 335.471 241.262 333.688 239.787 332.213C238.312 330.738 236.529 330 234.437 330H227.562C225.471 330 223.688 330.738 222.213 332.213C220.738 333.688 220 335.471 220 337.562V344.437C220 344.552 220.014 344.724 220.043 344.953H220V352H242V344.953H241.957C241.986 344.724 242 344.552 242 344.437V337.562Z'
        fill={props.color}
      />
      <path
        d='M286 337.562V330H271.562C269.471 330 267.688 330.738 266.213 332.213C264.738 333.688 264 335.471 264 337.562V344.437C264 346.529 264.738 348.312 266.213 349.787C267.688 351.262 269.471 352 271.562 352H286V337.562Z'
        fill={props.color}
      />
      <path d='M308 330H286V352H308V330Z' fill={props.color} />
      <path d='M330 330H308V352H330V330Z' fill={props.color} />
      <path d='M352 330H330V352H352V330Z' fill={props.color} />
      <path
        d='M374 330H352V352H366.437C368.529 352 370.312 351.262 371.787 349.787C373.262 348.312 374 346.529 374 344.437V330Z'
        fill={props.color}
      />
      <path
        d='M418 337.562V330H403.562C401.471 330 399.688 330.738 398.213 332.213C396.738 333.688 396 335.471 396 337.562V352H418V337.562Z'
        fill={props.color}
      />
      <path d='M440 330H418V352H440V330Z' fill={props.color} />
      <path
        d='M506 330H484V344.437C484 346.529 484.738 348.312 486.213 349.787C487.688 351.262 489.471 352 491.562 352H506V330Z'
        fill={props.color}
      />
      <path d='M528 330H506V352H528V330Z' fill={props.color} />
      <path
        d='M550 337.562C550 335.471 549.262 333.688 547.787 332.213C546.312 330.738 544.529 330 542.437 330H528V352H550V337.562Z'
        fill={props.color}
      />
      <path d='M638 330H616V352H638V330Z' fill={props.color} />
      <path d='M660 330H638V352H660V330Z' fill={props.color} />
      <path
        d='M770 344.437C770 346.529 769.262 348.312 767.787 349.787C766.312 351.262 764.529 352 762.437 352H755.562C753.472 352 751.688 351.262 750.213 349.787C748.738 348.312 748 346.529 748 344.437V337.562C748 335.472 748.738 333.688 750.213 332.213C751.689 330.738 753.472 330 755.562 330H762.437C764.529 330 766.312 330.738 767.787 332.213C769.262 333.689 770 335.472 770 337.562V344.437Z'
        fill={props.color}
      />
      <path
        d='M858 337.562V330H843.562C841.471 330 839.688 330.738 838.213 332.213C836.738 333.688 836 335.471 836 337.562V344.437C836 346.529 836.738 348.312 838.213 349.787C839.688 351.262 841.471 352 843.562 352H858V337.562Z'
        fill={props.color}
      />
      <path d='M880 330H858V352H880V330Z' fill={props.color} />
      <path
        d='M945.957 337.047H946V330H924V337.047H924.043C924.014 337.276 924 337.448 924 337.562V344.437C924 346.529 924.738 348.312 926.213 349.787C927.688 351.262 929.471 352 931.562 352H938.437C940.529 352 942.312 351.262 943.787 349.787C945.262 348.312 946 346.529 946 344.437V337.562C946 337.448 945.986 337.276 945.957 337.047Z'
        fill={props.color}
      />
      <path
        d='M110 359.562V352H95.5625C93.4714 352 91.6881 352.738 90.213 354.213C88.7379 355.688 88 357.471 88 359.562V374H110V359.562Z'
        fill={props.color}
      />
      <path d='M132 352H110V374H132V352Z' fill={props.color} />
      <path
        d='M198 366.437C198 368.529 197.262 370.312 195.787 371.787C194.312 373.262 192.529 374 190.437 374H183.562C181.472 374 179.688 373.262 178.213 371.787C176.738 370.312 176 368.529 176 366.437V359.562C176 357.472 176.738 355.688 178.213 354.213C179.689 352.738 181.472 352 183.562 352H190.437C192.529 352 194.312 352.738 195.787 354.213C197.262 355.689 198 357.472 198 359.562V366.437Z'
        fill={props.color}
      />
      <path
        d='M241.957 359.047H242V352H220V359.047H220.043C220.014 359.276 220 359.448 220 359.562V366.437C220 368.529 220.738 370.312 222.213 371.787C223.688 373.262 225.471 374 227.562 374H234.437C236.529 374 238.312 373.262 239.787 371.787C241.262 370.312 242 368.529 242 366.437V359.562C242 359.448 241.986 359.276 241.957 359.047Z'
        fill={props.color}
      />
      <path d='M330 352H308V374H330V352Z' fill={props.color} />
      <path
        d='M352 352H330V374H344.437C346.529 374 348.312 373.262 349.787 371.787C351.262 370.312 352 368.529 352 366.437V352Z'
        fill={props.color}
      />
      <path
        d='M396 359.562V352H381.562C379.471 352 377.688 352.738 376.213 354.213C374.738 355.688 374 357.471 374 359.562V374H396V359.562Z'
        fill={props.color}
      />
      <path d='M418 352H396V374H418V352Z' fill={props.color} />
      <path d='M440 352H418V374H440V352Z' fill={props.color} />
      <path
        d='M454.437 352H440V374H454.437C456.529 374 458.312 373.262 459.787 371.787C461.262 370.312 462 368.529 462 366.437V359.562C462 357.471 461.262 355.688 459.787 354.213C458.312 352.738 456.529 352 454.437 352Z'
        fill={props.color}
      />
      <path
        d='M550 352H528V366.437C528 368.529 528.738 370.312 530.213 371.787C531.688 373.262 533.471 374 535.562 374H550V352Z'
        fill={props.color}
      />
      <path d='M572 352H550V374H572V352Z' fill={props.color} />
      <path d='M594 352H572V374H594V352Z' fill={props.color} />
      <path d='M616 352H594V374H616V352Z' fill={props.color} />
      <path d='M638 352H616V374H638V352Z' fill={props.color} />
      <path d='M660 352H638V374H660V352Z' fill={props.color} />
      <path d='M682 352H660V374H682V352Z' fill={props.color} />
      <path d='M704 352H682V374H704V352Z' fill={props.color} />
      <path d='M726 352H704V374H726V352Z' fill={props.color} />
      <path
        d='M748 359.562C748 357.471 747.262 355.688 745.787 354.213C744.312 352.738 742.529 352 740.437 352H726V374H748V359.562Z'
        fill={props.color}
      />
      <path
        d='M792 366.437C792 368.529 791.262 370.312 789.787 371.787C788.312 373.262 786.529 374 784.437 374H777.562C775.472 374 773.688 373.262 772.213 371.787C770.738 370.312 770 368.529 770 366.437V359.562C770 357.472 770.738 355.688 772.213 354.213C773.689 352.738 775.472 352 777.562 352H784.437C786.529 352 788.312 352.738 789.787 354.213C791.262 355.689 792 357.472 792 359.562V366.437Z'
        fill={props.color}
      />
      <path
        d='M836 366.437C836 368.529 835.262 370.312 833.787 371.787C832.312 373.262 830.529 374 828.437 374H821.562C819.472 374 817.688 373.262 816.213 371.787C814.738 370.312 814 368.529 814 366.437V359.562C814 357.472 814.738 355.688 816.213 354.213C817.689 352.738 819.472 352 821.562 352H828.437C830.529 352 832.312 352.738 833.787 354.213C835.262 355.689 836 357.472 836 359.562V366.437Z'
        fill={props.color}
      />
      <path
        d='M879.957 359.047H880V352H858V359.047H858.043C858.014 359.276 858 359.448 858 359.562V366.437C858 368.529 858.738 370.312 860.213 371.787C861.688 373.262 863.471 374 865.562 374H872.437C874.529 374 876.312 373.262 877.787 371.787C879.262 370.312 880 368.529 880 366.437V359.562C880 359.448 879.986 359.276 879.957 359.047Z'
        fill={props.color}
      />
      <path
        d='M66 381.562V374H51.5625C49.4714 374 47.6881 374.738 46.213 376.213C44.7379 377.688 44 379.471 44 381.562V396H66V381.562Z'
        fill={props.color}
      />
      <path d='M88 374H66V396H88V374Z' fill={props.color} />
      <path d='M110 374H88V396H110V374Z' fill={props.color} />
      <path d='M132 374H110V396H132V374Z' fill={props.color} />
      <path
        d='M146.437 374H132V396H146.437C148.529 396 150.312 395.262 151.787 393.787C153.262 392.312 154 390.529 154 388.437V381.562C154 379.471 153.262 377.688 151.787 376.213C150.312 374.738 148.529 374 146.437 374Z'
        fill={props.color}
      />
      <path
        d='M220 388.437C220 390.529 219.262 392.312 217.787 393.787C216.312 395.262 214.529 396 212.437 396H205.562C203.472 396 201.688 395.262 200.213 393.787C198.738 392.312 198 390.529 198 388.437V381.562C198 379.472 198.738 377.688 200.213 376.213C201.689 374.738 203.472 374 205.562 374H212.437C214.529 374 216.312 374.738 217.787 376.213C219.262 377.689 220 379.472 220 381.562V388.437Z'
        fill={props.color}
      />
      <path
        d='M264 381.562C264 379.471 263.262 377.688 261.787 376.213C260.312 374.738 258.529 374 256.437 374H249.562C247.471 374 245.688 374.738 244.213 376.213C242.738 377.688 242 379.471 242 381.562V388.437C242 388.552 242.014 388.724 242.043 388.953H242V396H264V388.953H263.957C263.986 388.724 264 388.552 264 388.437V381.562Z'
        fill={props.color}
      />
      <path
        d='M308 381.562V374H293.562C291.471 374 289.688 374.738 288.213 376.213C286.738 377.688 286 379.471 286 381.562V388.437C286 390.529 286.738 392.312 288.213 393.787C289.688 395.262 291.471 396 293.562 396H308V381.562Z'
        fill={props.color}
      />
      <path d='M330 374H308V396H330V374Z' fill={props.color} />
      <path
        d='M374 381.562V374H359.562C357.471 374 355.688 374.738 354.213 376.213C352.738 377.688 352 379.471 352 381.562V388.437C352 390.529 352.738 392.312 354.213 393.787C355.688 395.262 357.471 396 359.562 396H374V381.562Z'
        fill={props.color}
      />
      <path
        d='M396 374H374V396H388.437C390.529 396 392.312 395.262 393.787 393.787C395.262 392.312 396 390.529 396 388.437V374Z'
        fill={props.color}
      />
      <path
        d='M484 381.562V374H469.562C467.471 374 465.688 374.738 464.213 376.213C462.738 377.688 462 379.471 462 381.562V396H484V381.562Z'
        fill={props.color}
      />
      <path
        d='M506 381.562C506 379.471 505.262 377.688 503.787 376.213C502.312 374.738 500.529 374 498.437 374H484V396H506V381.562Z'
        fill={props.color}
      />
      <path d='M572 374H550V396H572V374Z' fill={props.color} />
      <path
        d='M616 374H594V388.437C594 390.529 594.738 392.312 596.213 393.787C597.688 395.262 599.471 396 601.562 396H616V374Z'
        fill={props.color}
      />
      <path d='M638 374H616V396H638V374Z' fill={props.color} />
      <path d='M660 374H638V396H660V374Z' fill={props.color} />
      <path d='M748 374H726V396H748V374Z' fill={props.color} />
      <path
        d='M770 381.562C770 379.471 769.262 377.688 767.787 376.213C766.312 374.738 764.529 374 762.437 374H748V396H770V381.562Z'
        fill={props.color}
      />
      <path
        d='M814 388.437C814 390.529 813.262 392.312 811.787 393.787C810.312 395.262 808.529 396 806.437 396H799.562C797.472 396 795.688 395.262 794.213 393.787C792.738 392.312 792 390.529 792 388.437V381.562C792 379.472 792.738 377.688 794.213 376.213C795.689 374.738 797.472 374 799.562 374H806.437C808.529 374 810.312 374.738 811.787 376.213C813.262 377.689 814 379.472 814 381.562V388.437Z'
        fill={props.color}
      />
      <path
        d='M858 388.437C858 390.529 857.262 392.312 855.787 393.787C854.312 395.262 852.529 396 850.437 396H843.562C841.472 396 839.688 395.262 838.213 393.787C836.738 392.312 836 390.529 836 388.437V381.562C836 379.472 836.738 377.688 838.213 376.213C839.689 374.738 841.472 374 843.562 374H850.437C852.529 374 854.312 374.738 855.787 376.213C857.262 377.689 858 379.472 858 381.562V388.437Z'
        fill={props.color}
      />
      <path d='M66 396H44V418H66V396Z' fill={props.color} />
      <path
        d='M88 396H66V418H80.4375C82.5286 418 84.3119 417.262 85.787 415.787C87.2621 414.312 88 412.529 88 410.437V396Z'
        fill={props.color}
      />
      <path d='M132 396H110V418H132V396Z' fill={props.color} />
      <path
        d='M198 410.437C198 412.529 197.262 414.312 195.787 415.787C194.312 417.262 192.529 418 190.437 418H183.562C181.472 418 179.688 417.262 178.213 415.787C176.738 414.312 176 412.529 176 410.437V403.562C176 401.472 176.738 399.688 178.213 398.213C179.689 396.738 181.472 396 183.562 396H190.437C192.529 396 194.312 396.738 195.787 398.213C197.262 399.689 198 401.472 198 403.562V410.437Z'
        fill={props.color}
      />
      <path
        d='M264 396H242V410.437C242 412.529 242.738 414.312 244.213 415.787C245.688 417.262 247.471 418 249.562 418H264V396Z'
        fill={props.color}
      />
      <path
        d='M286 403.562C286 401.471 285.262 399.688 283.787 398.213C282.312 396.738 280.529 396 278.437 396H264V418H286V403.562Z'
        fill={props.color}
      />
      <path
        d='M330 396H308V410.437C308 412.529 308.738 414.312 310.213 415.787C311.688 417.262 313.471 418 315.562 418H330V396Z'
        fill={props.color}
      />
      <path
        d='M352 403.562C352 401.471 351.262 399.688 349.787 398.213C348.312 396.738 346.529 396 344.437 396H330V418H352V403.562Z'
        fill={props.color}
      />
      <path
        d='M418 403.562C418 401.471 417.262 399.688 415.787 398.213C414.312 396.738 412.529 396 410.437 396H403.562C401.471 396 399.688 396.738 398.213 398.213C396.738 399.688 396 401.471 396 403.562V410.437C396 410.552 396.014 410.724 396.043 410.953H396V418H418V410.953H417.957C417.986 410.724 418 410.552 418 410.437V403.562Z'
        fill={props.color}
      />
      <path
        d='M462 403.562V396H447.562C445.471 396 443.688 396.738 442.213 398.213C440.738 399.688 440 401.471 440 403.562V410.437C440 412.529 440.738 414.312 442.213 415.787C443.688 417.262 445.471 418 447.562 418H462V403.562Z'
        fill={props.color}
      />
      <path d='M484 396H462V418H484V396Z' fill={props.color} />
      <path d='M506 396H484V418H506V396Z' fill={props.color} />
      <path
        d='M520.437 396H506V418H520.437C522.529 418 524.312 417.262 525.787 415.787C527.262 414.312 528 412.529 528 410.437V403.562C528 401.471 527.262 399.688 525.787 398.213C524.312 396.738 522.529 396 520.437 396Z'
        fill={props.color}
      />
      <path
        d='M571.957 403.047H572V396H550V403.047H550.043C550.014 403.276 550 403.448 550 403.562V410.437C550 412.529 550.738 414.312 552.213 415.787C553.688 417.262 555.471 418 557.562 418H564.437C566.529 418 568.312 417.262 569.787 415.787C571.262 414.312 572 412.529 572 410.437V403.562C572 403.448 571.986 403.276 571.957 403.047Z'
        fill={props.color}
      />
      <path
        d='M659.957 403.047H660V396H638V403.047H638.043C638.014 403.276 638 403.448 638 403.562V410.437C638 412.529 638.738 414.312 640.213 415.787C641.688 417.262 643.471 418 645.562 418H652.437C654.529 418 656.312 417.262 657.787 415.787C659.262 414.312 660 412.529 660 410.437V403.562C660 403.448 659.986 403.276 659.957 403.047Z'
        fill={props.color}
      />
      <path
        d='M704 403.562C704 401.471 703.262 399.688 701.787 398.213C700.312 396.738 698.529 396 696.437 396H689.562C687.471 396 685.688 396.738 684.213 398.213C682.738 399.688 682 401.471 682 403.562V410.437C682 410.552 682.014 410.724 682.043 410.953H682V418H704V410.953H703.957C703.986 410.724 704 410.552 704 410.437V403.562Z'
        fill={props.color}
      />
      <path d='M748 396H726V418H748V396Z' fill={props.color} />
      <path d='M770 396H748V418H770V396Z' fill={props.color} />
      <path
        d='M784.437 396H770V418H784.437C786.529 418 788.312 417.262 789.787 415.787C791.262 414.312 792 412.529 792 410.437V403.562C792 401.471 791.262 399.688 789.787 398.213C788.312 396.738 786.529 396 784.437 396Z'
        fill={props.color}
      />
      <path
        d='M836 403.562C836 401.471 835.262 399.688 833.787 398.213C832.312 396.738 830.529 396 828.437 396H821.562C819.471 396 817.688 396.738 816.213 398.213C814.738 399.688 814 401.471 814 403.562V410.437C814 410.552 814.014 410.724 814.043 410.953H814V418H836V410.953H835.957C835.986 410.724 836 410.552 836 410.437V403.562Z'
        fill={props.color}
      />
      <path
        d='M880 403.562V396H865.562C863.471 396 861.688 396.738 860.213 398.213C858.738 399.688 858 401.471 858 403.562V410.437C858 412.529 858.738 414.312 860.213 415.787C861.688 417.262 863.471 418 865.562 418H880V403.562Z'
        fill={props.color}
      />
      <path
        d='M902 403.562C902 401.471 901.262 399.688 899.787 398.213C898.312 396.738 896.529 396 894.437 396H880V418H902V403.562Z'
        fill={props.color}
      />
      <path
        d='M65.9571 425.047H66V418H44V425.047H44.0429C44.0143 425.276 44 425.448 44 425.562V432.437C44 434.529 44.7377 436.312 46.213 437.787C47.6883 439.262 49.4714 440 51.5625 440H58.4375C60.5286 440 62.3119 439.262 63.787 437.787C65.2621 436.312 66 434.529 66 432.437V425.562C66 425.448 65.9861 425.276 65.9571 425.047Z'
        fill={props.color}
      />
      <path
        d='M132 418H110V432.437C110 434.529 110.738 436.312 112.213 437.787C113.688 439.262 115.471 440 117.562 440H132V418Z'
        fill={props.color}
      />
      <path
        d='M154 425.562C154 423.471 153.262 421.688 151.787 420.213C150.312 418.738 148.529 418 146.437 418H132V440H154V425.562Z'
        fill={props.color}
      />
      <path
        d='M242 432.437C242 434.529 241.262 436.312 239.787 437.787C238.312 439.262 236.529 440 234.437 440H227.562C225.472 440 223.688 439.262 222.213 437.787C220.738 436.312 220 434.529 220 432.437V425.562C220 423.472 220.738 421.688 222.213 420.213C223.689 418.738 225.472 418 227.562 418H234.437C236.529 418 238.312 418.738 239.787 420.213C241.262 421.689 242 423.472 242 425.562V432.437Z'
        fill={props.color}
      />
      <path d='M286 418H264V440H286V418Z' fill={props.color} />
      <path
        d='M352 418H330V432.437C330 434.529 330.738 436.312 332.213 437.787C333.688 439.262 335.471 440 337.562 440H352V418Z'
        fill={props.color}
      />
      <path
        d='M366.437 418H352V440H366.437C368.529 440 370.312 439.262 371.787 437.787C373.262 436.312 374 434.529 374 432.437V425.562C374 423.471 373.262 421.688 371.787 420.213C370.312 418.738 368.529 418 366.437 418Z'
        fill={props.color}
      />
      <path d='M418 418H396V440H418V418Z' fill={props.color} />
      <path
        d='M432.437 418H418V440H432.437C434.529 440 436.312 439.262 437.787 437.787C439.262 436.312 440 434.529 440 432.437V425.562C440 423.471 439.262 421.688 437.787 420.213C436.312 418.738 434.529 418 432.437 418Z'
        fill={props.color}
      />
      <path
        d='M594 425.562V418H579.562C577.471 418 575.688 418.738 574.213 420.213C572.738 421.688 572 423.471 572 425.562V432.437C572 434.529 572.738 436.312 574.213 437.787C575.688 439.262 577.471 440 579.562 440H594V425.562Z'
        fill={props.color}
      />
      <path
        d='M616 425.562C616 423.471 615.262 421.688 613.787 420.213C612.312 418.738 610.529 418 608.437 418H594V440H616V425.562Z'
        fill={props.color}
      />
      <path
        d='M682 425.562V418H667.562C665.471 418 663.688 418.738 662.213 420.213C660.738 421.688 660 423.471 660 425.562V432.437C660 434.529 660.738 436.312 662.213 437.787C663.688 439.262 665.471 440 667.562 440H682V425.562Z'
        fill={props.color}
      />
      <path d='M704 418H682V440H704V418Z' fill={props.color} />
      <path d='M726 418H704V440H726V418Z' fill={props.color} />
      <path
        d='M748 418H726V440H740.437C742.529 440 744.312 439.262 745.787 437.787C747.262 436.312 748 434.529 748 432.437V418Z'
        fill={props.color}
      />
      <path
        d='M814 425.562V418H799.562C797.471 418 795.688 418.738 794.213 420.213C792.738 421.688 792 423.471 792 425.562V432.437C792 434.529 792.738 436.312 794.213 437.787C795.688 439.262 797.471 440 799.562 440H814V425.562Z'
        fill={props.color}
      />
      <path d='M836 418H814V440H836V418Z' fill={props.color} />
      <path
        d='M858 425.562C858 423.471 857.262 421.688 855.787 420.213C854.312 418.738 852.529 418 850.437 418H836V440H858V425.562Z'
        fill={props.color}
      />
      <path
        d='M901.957 425.047H902V418H880V425.047H880.043C880.014 425.276 880 425.448 880 425.562V432.437C880 434.529 880.738 436.312 882.213 437.787C883.688 439.262 885.471 440 887.562 440H894.437C896.529 440 898.312 439.262 899.787 437.787C901.262 436.312 902 434.529 902 432.437V425.562C902 425.448 901.986 425.276 901.957 425.047Z'
        fill={props.color}
      />
      <path
        d='M946 432.437C946 434.529 945.262 436.312 943.787 437.787C942.312 439.262 940.529 440 938.437 440H931.562C929.472 440 927.688 439.262 926.213 437.787C924.738 436.312 924 434.529 924 432.437V425.562C924 423.472 924.738 421.688 926.213 420.213C927.689 418.738 929.472 418 931.562 418H938.437C940.529 418 942.312 418.738 943.787 420.213C945.262 421.689 946 423.472 946 425.562V432.437Z'
        fill={props.color}
      />
      <path
        d='M154 440H132V454.437C132 456.529 132.738 458.312 134.213 459.787C135.688 461.262 137.471 462 139.562 462H154V440Z'
        fill={props.color}
      />
      <path d='M176 440H154V462H176V440Z' fill={props.color} />
      <path d='M198 440H176V462H198V440Z' fill={props.color} />
      <path
        d='M212.437 440H198V462H212.437C214.529 462 216.312 461.262 217.787 459.787C219.262 458.312 220 456.529 220 454.437V447.562C220 445.471 219.262 443.688 217.787 442.213C216.312 440.738 214.529 440 212.437 440Z'
        fill={props.color}
      />
      <path d='M286 440H264V462H286V440Z' fill={props.color} />
      <path d='M308 440H286V462H308V440Z' fill={props.color} />
      <path
        d='M330 447.562C330 445.471 329.262 443.688 327.787 442.213C326.312 440.738 324.529 440 322.437 440H308V462H330V447.562Z'
        fill={props.color}
      />
      <path
        d='M417.957 447.047H418V440H396V447.047H396.043C396.014 447.276 396 447.448 396 447.562V454.437C396 456.529 396.738 458.312 398.213 459.787C399.688 461.262 401.471 462 403.562 462H410.437C412.529 462 414.312 461.262 415.787 459.787C417.262 458.312 418 456.529 418 454.437V447.562C418 447.448 417.986 447.276 417.957 447.047Z'
        fill={props.color}
      />
      <path
        d='M484 447.562C484 445.471 483.262 443.688 481.787 442.213C480.312 440.738 478.529 440 476.437 440H469.562C467.471 440 465.688 440.738 464.213 442.213C462.738 443.688 462 445.471 462 447.562V454.437C462 454.552 462.014 454.724 462.043 454.953H462V462H484V454.953H483.957C483.986 454.724 484 454.552 484 454.437V447.562Z'
        fill={props.color}
      />
      <path
        d='M550 447.562V440H535.562C533.471 440 531.688 440.738 530.213 442.213C528.738 443.688 528 445.471 528 447.562V462H550V447.562Z'
        fill={props.color}
      />
      <path
        d='M572 447.562C572 445.471 571.262 443.688 569.787 442.213C568.312 440.738 566.529 440 564.437 440H550V462H572V447.562Z'
        fill={props.color}
      />
      <path d='M616 440H594V462H616V440Z' fill={props.color} />
      <path d='M638 440H616V462H638V440Z' fill={props.color} />
      <path
        d='M652.437 440H638V462H652.437C654.529 462 656.312 461.262 657.787 459.787C659.262 458.312 660 456.529 660 454.437V447.562C660 445.471 659.262 443.688 657.787 442.213C656.312 440.738 654.529 440 652.437 440Z'
        fill={props.color}
      />
      <path d='M704 440H682V462H704V440Z' fill={props.color} />
      <path
        d='M792 454.437C792 456.529 791.262 458.312 789.787 459.787C788.312 461.262 786.529 462 784.437 462H777.562C775.472 462 773.688 461.262 772.213 459.787C770.738 458.312 770 456.529 770 454.437V447.562C770 445.472 770.738 443.688 772.213 442.213C773.689 440.738 775.472 440 777.562 440H784.437C786.529 440 788.312 440.738 789.787 442.213C791.262 443.689 792 445.472 792 447.562V454.437Z'
        fill={props.color}
      />
      <path d='M858 440H836V462H858V440Z' fill={props.color} />
      <path
        d='M924 454.437C924 456.529 923.262 458.312 921.787 459.787C920.312 461.262 918.529 462 916.437 462H909.562C907.472 462 905.688 461.262 904.213 459.787C902.738 458.312 902 456.529 902 454.437V447.562C902 445.472 902.738 443.688 904.213 442.213C905.689 440.738 907.472 440 909.562 440H916.437C918.529 440 920.312 440.738 921.787 442.213C923.262 443.689 924 445.472 924 447.562V454.437Z'
        fill={props.color}
      />
      <path
        d='M66 469.562V462H51.5625C49.4714 462 47.6881 462.738 46.213 464.213C44.7379 465.688 44 467.471 44 469.562V484H66V469.562Z'
        fill={props.color}
      />
      <path
        d='M88 469.562C88 467.471 87.2621 465.688 85.787 464.213C84.3119 462.738 82.5286 462 80.4375 462H66V484H88V469.562Z'
        fill={props.color}
      />
      <path
        d='M132 469.562C132 467.471 131.262 465.688 129.787 464.213C128.312 462.738 126.529 462 124.437 462H117.562C115.471 462 113.688 462.738 112.213 464.213C110.738 465.688 110 467.471 110 469.562V476.437C110 476.552 110.014 476.724 110.043 476.953H110V484H132V476.953H131.957C131.986 476.724 132 476.552 132 476.437V469.562Z'
        fill={props.color}
      />
      <path d='M176 462H154V484H176V462Z' fill={props.color} />
      <path d='M286 462H264V484H286V462Z' fill={props.color} />
      <path d='M308 462H286V484H308V462Z' fill={props.color} />
      <path
        d='M330 462H308V484H322.437C324.529 484 326.312 483.262 327.787 481.787C329.262 480.312 330 478.529 330 476.437V462Z'
        fill={props.color}
      />
      <path
        d='M374 469.562C374 467.471 373.262 465.688 371.787 464.213C370.312 462.738 368.529 462 366.437 462H359.562C357.471 462 355.688 462.738 354.213 464.213C352.738 465.688 352 467.471 352 469.562V476.437C352 476.552 352.014 476.724 352.043 476.953H352V484H374V476.953H373.957C373.986 476.724 374 476.552 374 476.437V469.562Z'
        fill={props.color}
      />
      <path
        d='M462 469.562V462H447.562C445.471 462 443.688 462.738 442.213 464.213C440.738 465.688 440 467.471 440 469.562V476.437C440 478.529 440.738 480.312 442.213 481.787C443.688 483.262 445.471 484 447.562 484H462V469.562Z'
        fill={props.color}
      />
      <path d='M484 462H462V484H484V462Z' fill={props.color} />
      <path
        d='M498.437 462H484V484H498.437C500.529 484 502.312 483.262 503.787 481.787C505.262 480.312 506 478.529 506 476.437V469.562C506 467.471 505.262 465.688 503.787 464.213C502.312 462.738 500.529 462 498.437 462Z'
        fill={props.color}
      />
      <path
        d='M550 462H528V476.437C528 478.529 528.738 480.312 530.213 481.787C531.688 483.262 533.471 484 535.562 484H550V462Z'
        fill={props.color}
      />
      <path d='M572 462H550V484H572V462Z' fill={props.color} />
      <path d='M594 462H572V484H594V462Z' fill={props.color} />
      <path
        d='M616 462H594V484H608.437C610.529 484 612.312 483.262 613.787 481.787C615.262 480.312 616 478.529 616 476.437V462Z'
        fill={props.color}
      />
      <path
        d='M704 462H682V476.437C682 478.529 682.738 480.312 684.213 481.787C685.688 483.262 687.471 484 689.562 484H704V462Z'
        fill={props.color}
      />
      <path d='M726 462H704V484H726V462Z' fill={props.color} />
      <path
        d='M740.437 462H726V484H740.437C742.529 484 744.312 483.262 745.787 481.787C747.262 480.312 748 478.529 748 476.437V469.562C748 467.471 747.262 465.688 745.787 464.213C744.312 462.738 742.529 462 740.437 462Z'
        fill={props.color}
      />
      <path
        d='M814 476.437C814 478.529 813.262 480.312 811.787 481.787C810.312 483.262 808.529 484 806.437 484H799.562C797.472 484 795.688 483.262 794.213 481.787C792.738 480.312 792 478.529 792 476.437V469.562C792 467.472 792.738 465.688 794.213 464.213C795.689 462.738 797.472 462 799.562 462H806.437C808.529 462 810.312 462.738 811.787 464.213C813.262 465.689 814 467.472 814 469.562V476.437Z'
        fill={props.color}
      />
      <path d='M858 462H836V484H858V462Z' fill={props.color} />
      <path
        d='M880 469.562C880 467.471 879.262 465.688 877.787 464.213C876.312 462.738 874.529 462 872.437 462H858V484H880V469.562Z'
        fill={props.color}
      />
      <path
        d='M66 484H44V498.437C44 500.529 44.7377 502.312 46.213 503.787C47.6883 505.262 49.4714 506 51.5625 506H66V484Z'
        fill={props.color}
      />
      <path
        d='M88 484H66V506H80.4375C82.5286 506 84.3119 505.262 85.787 503.787C87.2621 502.312 88 500.529 88 498.437V484Z'
        fill={props.color}
      />
      <path d='M132 484H110V506H132V484Z' fill={props.color} />
      <path d='M154 484H132V506H154V484Z' fill={props.color} />
      <path d='M176 484H154V506H176V484Z' fill={props.color} />
      <path
        d='M190.437 484H176V506H190.437C192.529 506 194.312 505.262 195.787 503.787C197.262 502.312 198 500.529 198 498.437V491.562C198 489.471 197.262 487.688 195.787 486.213C194.312 484.738 192.529 484 190.437 484Z'
        fill={props.color}
      />
      <path
        d='M242 491.562V484H227.562C225.471 484 223.688 484.738 222.213 486.213C220.738 487.688 220 489.471 220 491.562V498.437C220 500.529 220.738 502.312 222.213 503.787C223.688 505.262 225.471 506 227.562 506H242V491.562Z'
        fill={props.color}
      />
      <path d='M264 484H242V506H264V484Z' fill={props.color} />
      <path d='M286 484H264V506H286V484Z' fill={props.color} />
      <path d='M308 484H286V506H308V484Z' fill={props.color} />
      <path
        d='M352 491.562V484H337.562C335.471 484 333.688 484.738 332.213 486.213C330.738 487.688 330 489.471 330 491.562V506H352V491.562Z'
        fill={props.color}
      />
      <path d='M374 484H352V506H374V484Z' fill={props.color} />
      <path d='M484 484H462V506H484V484Z' fill={props.color} />
      <path
        d='M593.957 491.047H594V484H572V491.047H572.043C572.014 491.276 572 491.448 572 491.562V498.437C572 500.529 572.738 502.312 574.213 503.787C575.688 505.262 577.471 506 579.562 506H586.437C588.529 506 590.312 505.262 591.787 503.787C593.262 502.312 594 500.529 594 498.437V491.562C594 491.448 593.986 491.276 593.957 491.047Z'
        fill={props.color}
      />
      <path
        d='M638 491.562V484H623.562C621.471 484 619.688 484.738 618.213 486.213C616.738 487.688 616 489.471 616 491.562V506H638V491.562Z'
        fill={props.color}
      />
      <path d='M660 484H638V506H660V484Z' fill={props.color} />
      <path
        d='M674.437 484H660V506H674.437C676.529 506 678.312 505.262 679.787 503.787C681.262 502.312 682 500.529 682 498.437V491.562C682 489.471 681.262 487.688 679.787 486.213C678.312 484.738 676.529 484 674.437 484Z'
        fill={props.color}
      />
      <path
        d='M770 491.562V484H755.562C753.471 484 751.688 484.738 750.213 486.213C748.738 487.688 748 489.471 748 491.562V498.437C748 500.529 748.738 502.312 750.213 503.787C751.688 505.262 753.471 506 755.562 506H770V491.562Z'
        fill={props.color}
      />
      <path
        d='M784.437 484H770V506H784.437C786.529 506 788.312 505.262 789.787 503.787C791.262 502.312 792 500.529 792 498.437V491.562C792 489.471 791.262 487.688 789.787 486.213C788.312 484.738 786.529 484 784.437 484Z'
        fill={props.color}
      />
      <path
        d='M858 484H836V498.437C836 500.529 836.738 502.312 838.213 503.787C839.688 505.262 841.471 506 843.562 506H858V484Z'
        fill={props.color}
      />
      <path d='M880 484H858V506H880V484Z' fill={props.color} />
      <path
        d='M902 491.562C902 489.471 901.262 487.688 899.787 486.213C898.312 484.738 896.529 484 894.437 484H880V506H902V491.562Z'
        fill={props.color}
      />
      <path
        d='M110 513.562V506H95.5625C93.4714 506 91.6881 506.738 90.213 508.213C88.7379 509.688 88 511.471 88 513.562V528H110V513.562Z'
        fill={props.color}
      />
      <path d='M132 506H110V528H132V506Z' fill={props.color} />
      <path d='M154 506H132V528H154V506Z' fill={props.color} />
      <path
        d='M286 506H264V520.437C264 522.529 264.738 524.312 266.213 525.787C267.688 527.262 269.471 528 271.562 528H286V506Z'
        fill={props.color}
      />
      <path d='M308 506H286V528H308V506Z' fill={props.color} />
      <path d='M330 506H308V528H330V506Z' fill={props.color} />
      <path d='M352 506H330V528H352V506Z' fill={props.color} />
      <path d='M374 506H352V528H374V506Z' fill={props.color} />
      <path
        d='M396 513.562C396 511.471 395.262 509.688 393.787 508.213C392.312 506.738 390.529 506 388.437 506H374V528H396V513.562Z'
        fill={props.color}
      />
      <path
        d='M462 513.562V506H447.562C445.471 506 443.688 506.738 442.213 508.213C440.738 509.688 440 511.471 440 513.562V520.437C440 522.529 440.738 524.312 442.213 525.787C443.688 527.262 445.471 528 447.562 528H462V513.562Z'
        fill={props.color}
      />
      <path d='M484 506H462V528H484V506Z' fill={props.color} />
      <path
        d='M498.437 506H484V528H498.437C500.529 528 502.312 527.262 503.787 525.787C505.262 524.312 506 522.529 506 520.437V513.562C506 511.471 505.262 509.688 503.787 508.213C502.312 506.738 500.529 506 498.437 506Z'
        fill={props.color}
      />
      <path
        d='M550 520.437C550 522.529 549.262 524.312 547.787 525.787C546.312 527.262 544.529 528 542.437 528H535.562C533.472 528 531.688 527.262 530.213 525.787C528.738 524.312 528 522.529 528 520.437V513.562C528 511.472 528.738 509.688 530.213 508.213C531.689 506.738 533.472 506 535.562 506H542.437C544.529 506 546.312 506.738 547.787 508.213C549.262 509.689 550 511.472 550 513.562V520.437Z'
        fill={props.color}
      />
      <path
        d='M616 513.562V506H601.562C599.471 506 597.688 506.738 596.213 508.213C594.738 509.688 594 511.471 594 513.562V520.437C594 522.529 594.738 524.312 596.213 525.787C597.688 527.262 599.471 528 601.562 528H616V513.562Z'
        fill={props.color}
      />
      <path
        d='M638 506H616V528H630.437C632.529 528 634.312 527.262 635.787 525.787C637.262 524.312 638 522.529 638 520.437V506Z'
        fill={props.color}
      />
      <path
        d='M726 513.562V506H711.562C709.471 506 707.688 506.738 706.213 508.213C704.738 509.688 704 511.471 704 513.562V528H726V513.562Z'
        fill={props.color}
      />
      <path
        d='M740.437 506H726V528H740.437C742.529 528 744.312 527.262 745.787 525.787C747.262 524.312 748 522.529 748 520.437V513.562C748 511.471 747.262 509.688 745.787 508.213C744.312 506.738 742.529 506 740.437 506Z'
        fill={props.color}
      />
      <path
        d='M814 513.562V506H799.562C797.471 506 795.688 506.738 794.213 508.213C792.738 509.688 792 511.471 792 513.562V528H814V513.562Z'
        fill={props.color}
      />
      <path
        d='M828.437 506H814V528H828.437C830.529 528 832.312 527.262 833.787 525.787C835.262 524.312 836 522.529 836 520.437V513.562C836 511.471 835.262 509.688 833.787 508.213C832.312 506.738 830.529 506 828.437 506Z'
        fill={props.color}
      />
      <path
        d='M880 506H858V520.437C858 522.529 858.738 524.312 860.213 525.787C861.688 527.262 863.471 528 865.562 528H880V506Z'
        fill={props.color}
      />
      <path d='M902 506H880V528H902V506Z' fill={props.color} />
      <path d='M924 506H902V528H924V506Z' fill={props.color} />
      <path
        d='M938.437 506H924V528H938.437C940.529 528 942.312 527.262 943.787 525.787C945.262 524.312 946 522.529 946 520.437V513.562C946 511.471 945.262 509.688 943.787 508.213C942.312 506.738 940.529 506 938.437 506Z'
        fill={props.color}
      />
      <path
        d='M88 535.562V528H73.5625C71.4714 528 69.6881 528.738 68.213 530.213C66.7379 531.688 66 533.471 66 535.562V542.437C66 544.529 66.7377 546.312 68.213 547.787C69.6883 549.262 71.4714 550 73.5625 550H88V535.562Z'
        fill={props.color}
      />
      <path d='M110 528H88V550H110V528Z' fill={props.color} />
      <path d='M132 528H110V550H132V528Z' fill={props.color} />
      <path
        d='M154 528H132V550H146.437C148.529 550 150.312 549.262 151.787 547.787C153.262 546.312 154 544.529 154 542.437V528Z'
        fill={props.color}
      />
      <path
        d='M198 542.437C198 544.529 197.262 546.312 195.787 547.787C194.312 549.262 192.529 550 190.437 550H183.562C181.472 550 179.688 549.262 178.213 547.787C176.738 546.312 176 544.529 176 542.437V535.562C176 533.472 176.738 531.688 178.213 530.213C179.689 528.738 181.472 528 183.562 528H190.437C192.529 528 194.312 528.738 195.787 530.213C197.262 531.689 198 533.472 198 535.562V542.437Z'
        fill={props.color}
      />
      <path
        d='M264 542.437C264 544.529 263.262 546.312 261.787 547.787C260.312 549.262 258.529 550 256.437 550H249.562C247.472 550 245.688 549.262 244.213 547.787C242.738 546.312 242 544.529 242 542.437V535.562C242 533.472 242.738 531.688 244.213 530.213C245.689 528.738 247.472 528 249.562 528H256.437C258.529 528 260.312 528.738 261.787 530.213C263.262 531.689 264 533.472 264 535.562V542.437Z'
        fill={props.color}
      />
      <path d='M396 528H374V550H396V528Z' fill={props.color} />
      <path d='M418 528H396V550H418V528Z' fill={props.color} />
      <path
        d='M432.437 528H418V550H432.437C434.529 550 436.312 549.262 437.787 547.787C439.262 546.312 440 544.529 440 542.437V535.562C440 533.471 439.262 531.688 437.787 530.213C436.312 528.738 434.529 528 432.437 528Z'
        fill={props.color}
      />
      <path
        d='M483.957 535.047H484V528H462V535.047H462.043C462.014 535.276 462 535.448 462 535.562V542.437C462 544.529 462.738 546.312 464.213 547.787C465.688 549.262 467.471 550 469.562 550H476.437C478.529 550 480.312 549.262 481.787 547.787C483.262 546.312 484 544.529 484 542.437V535.562C484 535.448 483.986 535.276 483.957 535.047Z'
        fill={props.color}
      />
      <path
        d='M528 535.562C528 533.471 527.262 531.688 525.787 530.213C524.312 528.738 522.529 528 520.437 528H513.562C511.471 528 509.688 528.738 508.213 530.213C506.738 531.688 506 533.471 506 535.562V542.437C506 542.552 506.014 542.724 506.043 542.953H506V550H528V542.953H527.957C527.986 542.724 528 542.552 528 542.437V535.562Z'
        fill={props.color}
      />
      <path
        d='M660 535.562V528H645.562C643.471 528 641.688 528.738 640.213 530.213C638.738 531.688 638 533.471 638 535.562V542.437C638 544.529 638.738 546.312 640.213 547.787C641.688 549.262 643.471 550 645.562 550H660V535.562Z'
        fill={props.color}
      />
      <path
        d='M682 535.562C682 533.471 681.262 531.688 679.787 530.213C678.312 528.738 676.529 528 674.437 528H660V550H682V535.562Z'
        fill={props.color}
      />
      <path
        d='M725.957 535.047H726V528H704V535.047H704.043C704.014 535.276 704 535.448 704 535.562V542.437C704 544.529 704.738 546.312 706.213 547.787C707.688 549.262 709.471 550 711.562 550H718.437C720.529 550 722.312 549.262 723.787 547.787C725.262 546.312 726 544.529 726 542.437V535.562C726 535.448 725.986 535.276 725.957 535.047Z'
        fill={props.color}
      />
      <path
        d='M792 535.562V528H777.562C775.471 528 773.688 528.738 772.213 530.213C770.738 531.688 770 533.471 770 535.562V542.437C770 544.529 770.738 546.312 772.213 547.787C773.688 549.262 775.471 550 777.562 550H792V535.562Z'
        fill={props.color}
      />
      <path
        d='M814 528H792V550H806.437C808.529 550 810.312 549.262 811.787 547.787C813.262 546.312 814 544.529 814 542.437V528Z'
        fill={props.color}
      />
      <path d='M902 528H880V550H902V528Z' fill={props.color} />
      <path
        d='M176 564.437C176 566.529 175.262 568.312 173.787 569.787C172.312 571.262 170.529 572 168.437 572H161.562C159.472 572 157.688 571.262 156.213 569.787C154.738 568.312 154 566.529 154 564.437V557.562C154 555.472 154.738 553.688 156.213 552.213C157.689 550.738 159.472 550 161.562 550H168.437C170.529 550 172.312 550.738 173.787 552.213C175.262 553.689 176 555.472 176 557.562V564.437Z'
        fill={props.color}
      />
      <path
        d='M220 557.562V550H205.562C203.471 550 201.688 550.738 200.213 552.213C198.738 553.688 198 555.471 198 557.562V572H220V557.562Z'
        fill={props.color}
      />
      <path
        d='M234.437 550H220V572H234.437C236.529 572 238.312 571.262 239.787 569.787C241.262 568.312 242 566.529 242 564.437V557.562C242 555.471 241.262 553.688 239.787 552.213C238.312 550.738 236.529 550 234.437 550Z'
        fill={props.color}
      />
      <path
        d='M352 557.562C352 555.471 351.262 553.688 349.787 552.213C348.312 550.738 346.529 550 344.437 550H337.562C335.471 550 333.688 550.738 332.213 552.213C330.738 553.688 330 555.471 330 557.562V564.437C330 564.552 330.014 564.724 330.043 564.953H330V572H352V564.953H351.957C351.986 564.724 352 564.552 352 564.437V557.562Z'
        fill={props.color}
      />
      <path d='M396 550H374V572H396V550Z' fill={props.color} />
      <path
        d='M506 557.562V550H491.562C489.471 550 487.688 550.738 486.213 552.213C484.738 553.688 484 555.471 484 557.562V572H506V557.562Z'
        fill={props.color}
      />
      <path d='M528 550H506V572H528V550Z' fill={props.color} />
      <path
        d='M542.437 550H528V572H542.437C544.529 572 546.312 571.262 547.787 569.787C549.262 568.312 550 566.529 550 564.437V557.562C550 555.471 549.262 553.688 547.787 552.213C546.312 550.738 544.529 550 542.437 550Z'
        fill={props.color}
      />
      <path
        d='M594 557.562V550H579.562C577.471 550 575.688 550.738 574.213 552.213C572.738 553.688 572 555.471 572 557.562V572H594V557.562Z'
        fill={props.color}
      />
      <path d='M616 550H594V572H616V550Z' fill={props.color} />
      <path
        d='M638 557.562C638 555.471 637.262 553.688 635.787 552.213C634.312 550.738 632.529 550 630.437 550H616V572H638V557.562Z'
        fill={props.color}
      />
      <path
        d='M681.957 557.047H682V550H660V557.047H660.043C660.014 557.276 660 557.448 660 557.562V564.437C660 566.529 660.738 568.312 662.213 569.787C663.688 571.262 665.471 572 667.562 572H674.437C676.529 572 678.312 571.262 679.787 569.787C681.262 568.312 682 566.529 682 564.437V557.562C682 557.448 681.986 557.276 681.957 557.047Z'
        fill={props.color}
      />
      <path
        d='M836 564.437C836 566.529 835.262 568.312 833.787 569.787C832.312 571.262 830.529 572 828.437 572H821.562C819.472 572 817.688 571.262 816.213 569.787C814.738 568.312 814 566.529 814 564.437V557.562C814 555.472 814.738 553.688 816.213 552.213C817.689 550.738 819.472 550 821.562 550H828.437C830.529 550 832.312 550.738 833.787 552.213C835.262 553.689 836 555.472 836 557.562V564.437Z'
        fill={props.color}
      />
      <path
        d='M880 557.562V550H865.562C863.471 550 861.688 550.738 860.213 552.213C858.738 553.688 858 555.471 858 557.562V564.437C858 566.529 858.738 568.312 860.213 569.787C861.688 571.262 863.471 572 865.562 572H880V557.562Z'
        fill={props.color}
      />
      <path
        d='M902 550H880V572H894.437C896.529 572 898.312 571.262 899.787 569.787C901.262 568.312 902 566.529 902 564.437V550Z'
        fill={props.color}
      />
      <path
        d='M88 579.562V572H73.5625C71.4714 572 69.6881 572.738 68.213 574.213C66.7379 575.688 66 577.471 66 579.562V586.437C66 588.529 66.7377 590.312 68.213 591.787C69.6883 593.262 71.4714 594 73.5625 594H88V579.562Z'
        fill={props.color}
      />
      <path d='M110 572H88V594H110V572Z' fill={props.color} />
      <path
        d='M124.437 572H110V594H124.437C126.529 594 128.312 593.262 129.787 591.787C131.262 590.312 132 588.529 132 586.437V579.562C132 577.471 131.262 575.688 129.787 574.213C128.312 572.738 126.529 572 124.437 572Z'
        fill={props.color}
      />
      <path
        d='M198 579.562V572H183.562C181.471 572 179.688 572.738 178.213 574.213C176.738 575.688 176 577.471 176 579.562V586.437C176 588.529 176.738 590.312 178.213 591.787C179.688 593.262 181.471 594 183.562 594H198V579.562Z'
        fill={props.color}
      />
      <path
        d='M220 572H198V594H212.437C214.529 594 216.312 593.262 217.787 591.787C219.262 590.312 220 588.529 220 586.437V572Z'
        fill={props.color}
      />
      <path
        d='M264 579.562V572H249.562C247.471 572 245.688 572.738 244.213 574.213C242.738 575.688 242 577.471 242 579.562V594H264V579.562Z'
        fill={props.color}
      />
      <path
        d='M278.437 572H264V594H278.437C280.529 594 282.312 593.262 283.787 591.787C285.262 590.312 286 588.529 286 586.437V579.562C286 577.471 285.262 575.688 283.787 574.213C282.312 572.738 280.529 572 278.437 572Z'
        fill={props.color}
      />
      <path
        d='M330 579.562V572H315.562C313.471 572 311.688 572.738 310.213 574.213C308.738 575.688 308 577.471 308 579.562V594H330V579.562Z'
        fill={props.color}
      />
      <path d='M352 572H330V594H352V572Z' fill={props.color} />
      <path d='M374 572H352V594H374V572Z' fill={props.color} />
      <path d='M396 572H374V594H396V572Z' fill={props.color} />
      <path
        d='M410.437 572H396V594H410.437C412.529 594 414.312 593.262 415.787 591.787C417.262 590.312 418 588.529 418 586.437V579.562C418 577.471 417.262 575.688 415.787 574.213C414.312 572.738 412.529 572 410.437 572Z'
        fill={props.color}
      />
      <path
        d='M462 579.562V572H447.562C445.471 572 443.688 572.738 442.213 574.213C440.738 575.688 440 577.471 440 579.562V594H462V579.562Z'
        fill={props.color}
      />
      <path d='M484 572H462V594H484V572Z' fill={props.color} />
      <path
        d='M506 572H484V594H498.437C500.529 594 502.312 593.262 503.787 591.787C505.262 590.312 506 588.529 506 586.437V572Z'
        fill={props.color}
      />
      <path
        d='M594 572H572V586.437C572 588.529 572.738 590.312 574.213 591.787C575.688 593.262 577.471 594 579.562 594H594V572Z'
        fill={props.color}
      />
      <path d='M616 572H594V594H616V572Z' fill={props.color} />
      <path d='M638 572H616V594H638V572Z' fill={props.color} />
      <path
        d='M704 579.562V572H689.562C687.471 572 685.688 572.738 684.213 574.213C682.738 575.688 682 577.471 682 579.562V586.437C682 588.529 682.738 590.312 684.213 591.787C685.688 593.262 687.471 594 689.562 594H704V579.562Z'
        fill={props.color}
      />
      <path d='M726 572H704V594H726V572Z' fill={props.color} />
      <path
        d='M748 579.562C748 577.471 747.262 575.688 745.787 574.213C744.312 572.738 742.529 572 740.437 572H726V594H748V579.562Z'
        fill={props.color}
      />
      <path
        d='M792 579.562C792 577.471 791.262 575.688 789.787 574.213C788.312 572.738 786.529 572 784.437 572H777.562C775.471 572 773.688 572.738 772.213 574.213C770.738 575.688 770 577.471 770 579.562V586.437C770 586.552 770.014 586.724 770.043 586.953H770V594H792V586.953H791.957C791.986 586.724 792 586.552 792 586.437V579.562Z'
        fill={props.color}
      />
      <path
        d='M858 579.562C858 577.471 857.262 575.688 855.787 574.213C854.312 572.738 852.529 572 850.437 572H843.562C841.471 572 839.688 572.738 838.213 574.213C836.738 575.688 836 577.471 836 579.562V586.437C836 586.552 836.014 586.724 836.043 586.953H836V594H858V586.953H857.957C857.986 586.724 858 586.552 858 586.437V579.562Z'
        fill={props.color}
      />
      <path
        d='M946 579.562C946 577.471 945.262 575.688 943.787 574.213C942.312 572.738 940.529 572 938.437 572H931.562C929.471 572 927.688 572.738 926.213 574.213C924.738 575.688 924 577.471 924 579.562V586.437C924 586.552 924.014 586.724 924.043 586.953H924V594H946V586.953H945.957C945.986 586.724 946 586.552 946 586.437V579.562Z'
        fill={props.color}
      />
      <path
        d='M66 601.562C66 599.471 65.2621 597.688 63.787 596.213C62.3119 594.738 60.5286 594 58.4375 594H51.5625C49.4714 594 47.6881 594.738 46.213 596.213C44.7379 597.688 44 599.471 44 601.562V608.437C44 608.552 44.0143 608.724 44.0429 608.953H44V616H66V608.953H65.9571C65.9861 608.724 66 608.552 66 608.437V601.562Z'
        fill={props.color}
      />
      <path
        d='M176 608.437C176 610.529 175.262 612.312 173.787 613.787C172.312 615.262 170.529 616 168.437 616H161.562C159.472 616 157.688 615.262 156.213 613.787C154.738 612.312 154 610.529 154 608.437V601.562C154 599.472 154.738 597.688 156.213 596.213C157.689 594.738 159.472 594 161.562 594H168.437C170.529 594 172.312 594.738 173.787 596.213C175.262 597.689 176 599.472 176 601.562V608.437Z'
        fill={props.color}
      />
      <path d='M264 594H242V616H264V594Z' fill={props.color} />
      <path
        d='M308 601.562V594H293.562C291.471 594 289.688 594.738 288.213 596.213C286.738 597.688 286 599.471 286 601.562V608.437C286 610.529 286.738 612.312 288.213 613.787C289.688 615.262 291.471 616 293.562 616H308V601.562Z'
        fill={props.color}
      />
      <path d='M330 594H308V616H330V594Z' fill={props.color} />
      <path d='M352 594H330V616H352V594Z' fill={props.color} />
      <path d='M374 594H352V616H374V594Z' fill={props.color} />
      <path d='M396 594H374V616H396V594Z' fill={props.color} />
      <path
        d='M440 601.562V594H425.562C423.471 594 421.688 594.738 420.213 596.213C418.738 597.688 418 599.471 418 601.562V608.437C418 610.529 418.738 612.312 420.213 613.787C421.688 615.262 423.471 616 425.562 616H440V601.562Z'
        fill={props.color}
      />
      <path
        d='M462 594H440V616H454.437C456.529 616 458.312 615.262 459.787 613.787C461.262 612.312 462 610.529 462 608.437V594Z'
        fill={props.color}
      />
      <path
        d='M528 608.437C528 610.529 527.262 612.312 525.787 613.787C524.312 615.262 522.529 616 520.437 616H513.562C511.472 616 509.688 615.262 508.213 613.787C506.738 612.312 506 610.529 506 608.437V601.562C506 599.472 506.738 597.688 508.213 596.213C509.689 594.738 511.472 594 513.562 594H520.437C522.529 594 524.312 594.738 525.787 596.213C527.262 597.689 528 599.472 528 601.562V608.437Z'
        fill={props.color}
      />
      <path d='M616 594H594V616H616V594Z' fill={props.color} />
      <path
        d='M638 594H616V616H630.437C632.529 616 634.312 615.262 635.787 613.787C637.262 612.312 638 610.529 638 608.437V594Z'
        fill={props.color}
      />
      <path
        d='M682 601.562C682 599.471 681.262 597.688 679.787 596.213C678.312 594.738 676.529 594 674.437 594H667.562C665.471 594 663.688 594.738 662.213 596.213C660.738 597.688 660 599.471 660 601.562V608.437C660 608.552 660.014 608.724 660.043 608.953H660V616H682V608.953H681.957C681.986 608.724 682 608.552 682 608.437V601.562Z'
        fill={props.color}
      />
      <path
        d='M726 594H704V608.437C704 610.529 704.738 612.312 706.213 613.787C707.688 615.262 709.471 616 711.562 616H726V594Z'
        fill={props.color}
      />
      <path
        d='M748 594H726V616H740.437C742.529 616 744.312 615.262 745.787 613.787C747.262 612.312 748 610.529 748 608.437V594Z'
        fill={props.color}
      />
      <path
        d='M792 594H770V608.437C770 610.529 770.738 612.312 772.213 613.787C773.688 615.262 775.471 616 777.562 616H792V594Z'
        fill={props.color}
      />
      <path d='M814 594H792V616H814V594Z' fill={props.color} />
      <path d='M836 594H814V616H836V594Z' fill={props.color} />
      <path d='M858 594H836V616H858V594Z' fill={props.color} />
      <path
        d='M872.437 594H858V616H872.437C874.529 616 876.312 615.262 877.787 613.787C879.262 612.312 880 610.529 880 608.437V601.562C880 599.471 879.262 597.688 877.787 596.213C876.312 594.738 874.529 594 872.437 594Z'
        fill={props.color}
      />
      <path
        d='M924 601.562V594H909.562C907.471 594 905.688 594.738 904.213 596.213C902.738 597.688 902 599.471 902 601.562V608.437C902 610.529 902.738 612.312 904.213 613.787C905.688 615.262 907.471 616 909.562 616H924V601.562Z'
        fill={props.color}
      />
      <path
        d='M946 594H924V616H938.437C940.529 616 942.312 615.262 943.787 613.787C945.262 612.312 946 610.529 946 608.437V594Z'
        fill={props.color}
      />
      <path
        d='M66 616H44V630.437C44 632.529 44.7377 634.312 46.213 635.787C47.6883 637.262 49.4714 638 51.5625 638H66V616Z'
        fill={props.color}
      />
      <path d='M88 616H66V638H88V616Z' fill={props.color} />
      <path
        d='M102.437 616H88V638H102.437C104.529 638 106.312 637.262 107.787 635.787C109.262 634.312 110 632.529 110 630.437V623.562C110 621.471 109.262 619.688 107.787 618.213C106.312 616.738 104.529 616 102.437 616Z'
        fill={props.color}
      />
      <path
        d='M198 630.437C198 632.529 197.262 634.312 195.787 635.787C194.312 637.262 192.529 638 190.437 638H183.562C181.472 638 179.688 637.262 178.213 635.787C176.738 634.312 176 632.529 176 630.437V623.562C176 621.472 176.738 619.688 178.213 618.213C179.689 616.738 181.472 616 183.562 616H190.437C192.529 616 194.312 616.738 195.787 618.213C197.262 619.689 198 621.472 198 623.562V630.437Z'
        fill={props.color}
      />
      <path
        d='M242 623.562V616H227.562C225.471 616 223.688 616.738 222.213 618.213C220.738 619.688 220 621.471 220 623.562V638H242V623.562Z'
        fill={props.color}
      />
      <path d='M264 616H242V638H264V616Z' fill={props.color} />
      <path
        d='M286 623.562C286 621.471 285.262 619.688 283.787 618.213C282.312 616.738 280.529 616 278.437 616H264V638H286V623.562Z'
        fill={props.color}
      />
      <path d='M330 616H308V638H330V616Z' fill={props.color} />
      <path
        d='M352 616H330V638H344.437C346.529 638 348.312 637.262 349.787 635.787C351.262 634.312 352 632.529 352 630.437V616Z'
        fill={props.color}
      />
      <path
        d='M395.957 623.047H396V616H374V623.047H374.043C374.014 623.276 374 623.448 374 623.562V630.437C374 632.529 374.738 634.312 376.213 635.787C377.688 637.262 379.471 638 381.562 638H388.437C390.529 638 392.312 637.262 393.787 635.787C395.262 634.312 396 632.529 396 630.437V623.562C396 623.448 395.986 623.276 395.957 623.047Z'
        fill={props.color}
      />
      <path
        d='M484 623.562C484 621.471 483.262 619.688 481.787 618.213C480.312 616.738 478.529 616 476.437 616H469.562C467.471 616 465.688 616.738 464.213 618.213C462.738 619.688 462 621.471 462 623.562V630.437C462 630.552 462.014 630.724 462.043 630.953H462V638H484V630.953H483.957C483.986 630.724 484 630.552 484 630.437V623.562Z'
        fill={props.color}
      />
      <path d='M616 616H594V638H616V616Z' fill={props.color} />
      <path
        d='M660 623.562V616H645.562C643.471 616 641.688 616.738 640.213 618.213C638.738 619.688 638 621.471 638 623.562V638H660V623.562Z'
        fill={props.color}
      />
      <path d='M682 616H660V638H682V616Z' fill={props.color} />
      <path
        d='M696.437 616H682V638H696.437C698.529 638 700.312 637.262 701.787 635.787C703.262 634.312 704 632.529 704 630.437V623.562C704 621.471 703.262 619.688 701.787 618.213C700.312 616.738 698.529 616 696.437 616Z'
        fill={props.color}
      />
      <path
        d='M770 623.562C770 621.471 769.262 619.688 767.787 618.213C766.312 616.738 764.529 616 762.437 616H755.562C753.471 616 751.688 616.738 750.213 618.213C748.738 619.688 748 621.471 748 623.562V630.437C748 630.552 748.014 630.724 748.043 630.953H748V638H770V630.953H769.957C769.986 630.724 770 630.552 770 630.437V623.562Z'
        fill={props.color}
      />
      <path d='M814 616H792V638H814V616Z' fill={props.color} />
      <path d='M836 616H814V638H836V616Z' fill={props.color} />
      <path
        d='M858 616H836V638H850.437C852.529 638 854.312 637.262 855.787 635.787C857.262 634.312 858 632.529 858 630.437V616Z'
        fill={props.color}
      />
      <path d='M88 638H66V660H88V638Z' fill={props.color} />
      <path
        d='M176 652.437C176 654.529 175.262 656.312 173.787 657.787C172.312 659.262 170.529 660 168.437 660H161.562C159.472 660 157.688 659.262 156.213 657.787C154.738 656.312 154 654.529 154 652.437V645.562C154 643.472 154.738 641.688 156.213 640.213C157.689 638.738 159.472 638 161.562 638H168.437C170.529 638 172.312 638.738 173.787 640.213C175.262 641.689 176 643.472 176 645.562V652.437Z'
        fill={props.color}
      />
      <path
        d='M241.957 645.047H242V638H220V645.047H220.043C220.014 645.276 220 645.448 220 645.562V652.437C220 654.529 220.738 656.312 222.213 657.787C223.688 659.262 225.471 660 227.562 660H234.437C236.529 660 238.312 659.262 239.787 657.787C241.262 656.312 242 654.529 242 652.437V645.562C242 645.448 241.986 645.276 241.957 645.047Z'
        fill={props.color}
      />
      <path
        d='M286 638H264V652.437C264 654.529 264.738 656.312 266.213 657.787C267.688 659.262 269.471 660 271.562 660H286V638Z'
        fill={props.color}
      />
      <path d='M308 638H286V660H308V638Z' fill={props.color} />
      <path
        d='M330 638H308V660H322.437C324.529 660 326.312 659.262 327.787 657.787C329.262 656.312 330 654.529 330 652.437V638Z'
        fill={props.color}
      />
      <path
        d='M440 652.437C440 654.529 439.262 656.312 437.787 657.787C436.312 659.262 434.529 660 432.437 660H425.562C423.472 660 421.688 659.262 420.213 657.787C418.738 656.312 418 654.529 418 652.437V645.562C418 643.472 418.738 641.688 420.213 640.213C421.689 638.738 423.472 638 425.562 638H432.437C434.529 638 436.312 638.738 437.787 640.213C439.262 641.689 440 643.472 440 645.562V652.437Z'
        fill={props.color}
      />
      <path d='M484 638H462V660H484V638Z' fill={props.color} />
      <path
        d='M528 652.437C528 654.529 527.262 656.312 525.787 657.787C524.312 659.262 522.529 660 520.437 660H513.562C511.472 660 509.688 659.262 508.213 657.787C506.738 656.312 506 654.529 506 652.437V645.562C506 643.472 506.738 641.688 508.213 640.213C509.689 638.738 511.472 638 513.562 638H520.437C522.529 638 524.312 638.738 525.787 640.213C527.262 641.689 528 643.472 528 645.562V652.437Z'
        fill={props.color}
      />
      <path
        d='M572 645.562C572 643.471 571.262 641.688 569.787 640.213C568.312 638.738 566.529 638 564.437 638H557.562C555.471 638 553.688 638.738 552.213 640.213C550.738 641.688 550 643.471 550 645.562V652.437C550 652.552 550.014 652.724 550.043 652.953H550V660H572V652.953H571.957C571.986 652.724 572 652.552 572 652.437V645.562Z'
        fill={props.color}
      />
      <path d='M616 638H594V660H616V638Z' fill={props.color} />
      <path
        d='M660 638H638V652.437C638 654.529 638.738 656.312 640.213 657.787C641.688 659.262 643.471 660 645.562 660H660V638Z'
        fill={props.color}
      />
      <path
        d='M682 638H660V660H674.437C676.529 660 678.312 659.262 679.787 657.787C681.262 656.312 682 654.529 682 652.437V638Z'
        fill={props.color}
      />
      <path
        d='M748 645.562V638H733.562C731.471 638 729.688 638.738 728.213 640.213C726.738 641.688 726 643.471 726 645.562V660H748V645.562Z'
        fill={props.color}
      />
      <path d='M770 638H748V660H770V638Z' fill={props.color} />
      <path d='M792 638H770V660H792V638Z' fill={props.color} />
      <path d='M814 638H792V660H814V638Z' fill={props.color} />
      <path d='M836 638H814V660H836V638Z' fill={props.color} />
      <path
        d='M880 645.562C880 643.471 879.262 641.688 877.787 640.213C876.312 638.738 874.529 638 872.437 638H865.562C863.471 638 861.688 638.738 860.213 640.213C858.738 641.688 858 643.471 858 645.562V652.437C858 652.552 858.014 652.724 858.043 652.953H858V660H880V652.953H879.957C879.986 652.724 880 652.552 880 652.437V645.562Z'
        fill={props.color}
      />
      <path
        d='M924 652.437C924 654.529 923.262 656.312 921.787 657.787C920.312 659.262 918.529 660 916.437 660H909.562C907.472 660 905.688 659.262 904.213 657.787C902.738 656.312 902 654.529 902 652.437V645.562C902 643.472 902.738 641.688 904.213 640.213C905.689 638.738 907.472 638 909.562 638H916.437C918.529 638 920.312 638.738 921.787 640.213C923.262 641.689 924 643.472 924 645.562V652.437Z'
        fill={props.color}
      />
      <path
        d='M66 667.562V660H51.5625C49.4714 660 47.6881 660.738 46.213 662.213C44.7379 663.688 44 665.471 44 667.562V682H66V667.562Z'
        fill={props.color}
      />
      <path
        d='M88 660H66V682H80.4375C82.5286 682 84.3119 681.262 85.787 679.787C87.2621 678.312 88 676.529 88 674.437V660Z'
        fill={props.color}
      />
      <path
        d='M132 667.562C132 665.471 131.262 663.688 129.787 662.213C128.312 660.738 126.529 660 124.437 660H117.562C115.471 660 113.688 660.738 112.213 662.213C110.738 663.688 110 665.471 110 667.562V674.437C110 674.552 110.014 674.724 110.043 674.953H110V682H132V674.953H131.957C131.986 674.724 132 674.552 132 674.437V667.562Z'
        fill={props.color}
      />
      <path
        d='M198 674.437C198 676.529 197.262 678.312 195.787 679.787C194.312 681.262 192.529 682 190.437 682H183.562C181.472 682 179.688 681.262 178.213 679.787C176.738 678.312 176 676.529 176 674.437V667.562C176 665.472 176.738 663.688 178.213 662.213C179.689 660.738 181.472 660 183.562 660H190.437C192.529 660 194.312 660.738 195.787 662.213C197.262 663.689 198 665.472 198 667.562V674.437Z'
        fill={props.color}
      />
      <path d='M308 660H286V682H308V660Z' fill={props.color} />
      <path
        d='M374 667.562C374 665.471 373.262 663.688 371.787 662.213C370.312 660.738 368.529 660 366.437 660H359.562C357.471 660 355.688 660.738 354.213 662.213C352.738 663.688 352 665.471 352 667.562V674.437C352 674.552 352.014 674.724 352.043 674.953H352V682H374V674.953H373.957C373.986 674.724 374 674.552 374 674.437V667.562Z'
        fill={props.color}
      />
      <path
        d='M418 674.437C418 676.529 417.262 678.312 415.787 679.787C414.312 681.262 412.529 682 410.437 682H403.562C401.472 682 399.688 681.262 398.213 679.787C396.738 678.312 396 676.529 396 674.437V667.562C396 665.472 396.738 663.688 398.213 662.213C399.689 660.738 401.472 660 403.562 660H410.437C412.529 660 414.312 660.738 415.787 662.213C417.262 663.689 418 665.472 418 667.562V674.437Z'
        fill={props.color}
      />
      <path
        d='M462 667.562V660H447.562C445.471 660 443.688 660.738 442.213 662.213C440.738 663.688 440 665.471 440 667.562V674.437C440 676.529 440.738 678.312 442.213 679.787C443.688 681.262 445.471 682 447.562 682H462V667.562Z'
        fill={props.color}
      />
      <path d='M484 660H462V682H484V660Z' fill={props.color} />
      <path
        d='M506 667.562C506 665.471 505.262 663.688 503.787 662.213C502.312 660.738 500.529 660 498.437 660H484V682H506V667.562Z'
        fill={props.color}
      />
      <path
        d='M550 667.562V660H535.562C533.471 660 531.688 660.738 530.213 662.213C528.738 663.688 528 665.471 528 667.562V674.437C528 676.529 528.738 678.312 530.213 679.787C531.688 681.262 533.471 682 535.562 682H550V667.562Z'
        fill={props.color}
      />
      <path
        d='M572 660H550V682H564.437C566.529 682 568.312 681.262 569.787 679.787C571.262 678.312 572 676.529 572 674.437V660Z'
        fill={props.color}
      />
      <path
        d='M615.957 667.047H616V660H594V667.047H594.043C594.014 667.276 594 667.448 594 667.562V674.437C594 676.529 594.738 678.312 596.213 679.787C597.688 681.262 599.471 682 601.562 682H608.437C610.529 682 612.312 681.262 613.787 679.787C615.262 678.312 616 676.529 616 674.437V667.562C616 667.448 615.986 667.276 615.957 667.047Z'
        fill={props.color}
      />
      <path
        d='M704 667.562V660H689.562C687.471 660 685.688 660.738 684.213 662.213C682.738 663.688 682 665.471 682 667.562V682H704V667.562Z'
        fill={props.color}
      />
      <path d='M726 660H704V682H726V660Z' fill={props.color} />
      <path d='M748 660H726V682H748V660Z' fill={props.color} />
      <path
        d='M770 660H748V682H762.437C764.529 682 766.312 681.262 767.787 679.787C769.262 678.312 770 676.529 770 674.437V660Z'
        fill={props.color}
      />
      <path
        d='M814 660H792V674.437C792 676.529 792.738 678.312 794.213 679.787C795.688 681.262 797.471 682 799.562 682H814V660Z'
        fill={props.color}
      />
      <path
        d='M836 660H814V682H828.437C830.529 682 832.312 681.262 833.787 679.787C835.262 678.312 836 676.529 836 674.437V660Z'
        fill={props.color}
      />
      <path d='M880 660H858V682H880V660Z' fill={props.color} />
      <path
        d='M894.437 660H880V682H894.437C896.529 682 898.312 681.262 899.787 679.787C901.262 678.312 902 676.529 902 674.437V667.562C902 665.471 901.262 663.688 899.787 662.213C898.312 660.738 896.529 660 894.437 660Z'
        fill={props.color}
      />
      <path d='M66 682H44V704H66V682Z' fill={props.color} />
      <path
        d='M132 682H110V696.437C110 698.529 110.738 700.312 112.213 701.787C113.688 703.262 115.471 704 117.562 704H132V682Z'
        fill={props.color}
      />
      <path d='M154 682H132V704H154V682Z' fill={props.color} />
      <path
        d='M168.437 682H154V704H168.437C170.529 704 172.312 703.262 173.787 701.787C175.262 700.312 176 698.529 176 696.437V689.562C176 687.471 175.262 685.688 173.787 684.213C172.312 682.738 170.529 682 168.437 682Z'
        fill={props.color}
      />
      <path
        d='M286 689.562V682H271.562C269.471 682 267.688 682.738 266.213 684.213C264.738 685.688 264 687.471 264 689.562V696.437C264 698.529 264.738 700.312 266.213 701.787C267.688 703.262 269.471 704 271.562 704H286V689.562Z'
        fill={props.color}
      />
      <path
        d='M308 682H286V704H300.437C302.529 704 304.312 703.262 305.787 701.787C307.262 700.312 308 698.529 308 696.437V682Z'
        fill={props.color}
      />
      <path
        d='M352 689.562V682H337.562C335.471 682 333.688 682.738 332.213 684.213C330.738 685.688 330 687.471 330 689.562V704H352V689.562Z'
        fill={props.color}
      />
      <path d='M374 682H352V704H374V682Z' fill={props.color} />
      <path
        d='M484 682H462V696.437C462 698.529 462.738 700.312 464.213 701.787C465.688 703.262 467.471 704 469.562 704H484V682Z'
        fill={props.color}
      />
      <path d='M506 682H484V704H506V682Z' fill={props.color} />
      <path
        d='M520.437 682H506V704H520.437C522.529 704 524.312 703.262 525.787 701.787C527.262 700.312 528 698.529 528 696.437V689.562C528 687.471 527.262 685.688 525.787 684.213C524.312 682.738 522.529 682 520.437 682Z'
        fill={props.color}
      />
      <path
        d='M660 689.562V682H645.562C643.471 682 641.688 682.738 640.213 684.213C638.738 685.688 638 687.471 638 689.562V696.437C638 698.529 638.738 700.312 640.213 701.787C641.688 703.262 643.471 704 645.562 704H660V689.562Z'
        fill={props.color}
      />
      <path d='M682 682H660V704H682V682Z' fill={props.color} />
      <path
        d='M704 682H682V704H696.437C698.529 704 700.312 703.262 701.787 701.787C703.262 700.312 704 698.529 704 696.437V682Z'
        fill={props.color}
      />
      <path
        d='M792 689.562C792 687.471 791.262 685.688 789.787 684.213C788.312 682.738 786.529 682 784.437 682H777.562C775.471 682 773.688 682.738 772.213 684.213C770.738 685.688 770 687.471 770 689.562V696.437C770 696.552 770.014 696.724 770.043 696.953H770V704H792V696.953H791.957C791.986 696.724 792 696.552 792 696.437V689.562Z'
        fill={props.color}
      />
      <path
        d='M858 689.562V682H843.562C841.471 682 839.688 682.738 838.213 684.213C836.738 685.688 836 687.471 836 689.562V704H858V689.562Z'
        fill={props.color}
      />
      <path d='M880 682H858V704H880V682Z' fill={props.color} />
      <path
        d='M924 689.562V682H909.562C907.471 682 905.688 682.738 904.213 684.213C902.738 685.688 902 687.471 902 689.562V696.437C902 698.529 902.738 700.312 904.213 701.787C905.688 703.262 907.471 704 909.562 704H924V689.562Z'
        fill={props.color}
      />
      <path
        d='M938.437 682H924V704H938.437C940.529 704 942.312 703.262 943.787 701.787C945.262 700.312 946 698.529 946 696.437V689.562C946 687.471 945.262 685.688 943.787 684.213C942.312 682.738 940.529 682 938.437 682Z'
        fill={props.color}
      />
      <path d='M66 704H44V726H66V704Z' fill={props.color} />
      <path
        d='M110 718.437C110 720.529 109.262 722.312 107.787 723.787C106.312 725.262 104.529 726 102.437 726H95.5625C93.4716 726 91.6883 725.262 90.2132 723.787C88.7379 722.312 88 720.529 88 718.437V711.562C88 709.472 88.7377 707.688 90.213 706.213C91.6885 704.738 93.4716 704 95.5625 704H102.437C104.529 704 106.312 704.738 107.787 706.213C109.262 707.689 110 709.472 110 711.562V718.437Z'
        fill={props.color}
      />
      <path d='M154 704H132V726H154V704Z' fill={props.color} />
      <path
        d='M198 711.562V704H183.562C181.471 704 179.688 704.738 178.213 706.213C176.738 707.688 176 709.471 176 711.562V718.437C176 720.529 176.738 722.312 178.213 723.787C179.688 725.262 181.471 726 183.562 726H198V711.562Z'
        fill={props.color}
      />
      <path d='M220 704H198V726H220V704Z' fill={props.color} />
      <path
        d='M242 711.562C242 709.471 241.262 707.688 239.787 706.213C238.312 704.738 236.529 704 234.437 704H220V726H242V711.562Z'
        fill={props.color}
      />
      <path
        d='M330 711.562V704H315.562C313.471 704 311.688 704.738 310.213 706.213C308.738 707.688 308 709.471 308 711.562V718.437C308 720.529 308.738 722.312 310.213 723.787C311.688 725.262 313.471 726 315.562 726H330V711.562Z'
        fill={props.color}
      />
      <path d='M352 704H330V726H352V704Z' fill={props.color} />
      <path
        d='M374 704H352V726H366.437C368.529 726 370.312 725.262 371.787 723.787C373.262 722.312 374 720.529 374 718.437V704Z'
        fill={props.color}
      />
      <path
        d='M572 711.562V704H557.562C555.471 704 553.688 704.738 552.213 706.213C550.738 707.688 550 709.471 550 711.562V718.437C550 720.529 550.738 722.312 552.213 723.787C553.688 725.262 555.471 726 557.562 726H572V711.562Z'
        fill={props.color}
      />
      <path
        d='M586.437 704H572V726H586.437C588.529 726 590.312 725.262 591.787 723.787C593.262 722.312 594 720.529 594 718.437V711.562C594 709.471 593.262 707.688 591.787 706.213C590.312 704.738 588.529 704 586.437 704Z'
        fill={props.color}
      />
      <path
        d='M726 718.437C726 720.529 725.262 722.312 723.787 723.787C722.312 725.262 720.529 726 718.437 726H711.562C709.472 726 707.688 725.262 706.213 723.787C704.738 722.312 704 720.529 704 718.437V711.562C704 709.472 704.738 707.688 706.213 706.213C707.689 704.738 709.472 704 711.562 704H718.437C720.529 704 722.312 704.738 723.787 706.213C725.262 707.689 726 709.472 726 711.562V718.437Z'
        fill={props.color}
      />
      <path
        d='M770 711.562V704H755.562C753.471 704 751.688 704.738 750.213 706.213C748.738 707.688 748 709.471 748 711.562V718.437C748 720.529 748.738 722.312 750.213 723.787C751.688 725.262 753.471 726 755.562 726H770V711.562Z'
        fill={props.color}
      />
      <path d='M792 704H770V726H792V704Z' fill={props.color} />
      <path d='M814 704H792V726H814V704Z' fill={props.color} />
      <path d='M836 704H814V726H836V704Z' fill={props.color} />
      <path d='M858 704H836V726H858V704Z' fill={props.color} />
      <path
        d='M880 704H858V726H872.437C874.529 726 876.312 725.262 877.787 723.787C879.262 722.312 880 720.529 880 718.437V704Z'
        fill={props.color}
      />
      <path d='M66 726H44V748H66V726Z' fill={props.color} />
      <path
        d='M132 733.562V726H117.562C115.471 726 113.688 726.738 112.213 728.213C110.738 729.688 110 731.471 110 733.562V740.437C110 742.529 110.738 744.312 112.213 745.787C113.688 747.262 115.471 748 117.562 748H132V733.562Z'
        fill={props.color}
      />
      <path
        d='M154 726H132V748H146.437C148.529 748 150.312 747.262 151.787 745.787C153.262 744.312 154 742.529 154 740.437V726Z'
        fill={props.color}
      />
      <path
        d='M220 726H198V740.437C198 742.529 198.738 744.312 200.213 745.787C201.688 747.262 203.471 748 205.562 748H220V726Z'
        fill={props.color}
      />
      <path d='M242 726H220V748H242V726Z' fill={props.color} />
      <path d='M264 726H242V748H264V726Z' fill={props.color} />
      <path d='M286 726H264V748H286V726Z' fill={props.color} />
      <path
        d='M308 733.562C308 731.471 307.262 729.688 305.787 728.213C304.312 726.738 302.529 726 300.437 726H286V748H308V733.562Z'
        fill={props.color}
      />
      <path
        d='M396 740.437C396 742.529 395.262 744.312 393.787 745.787C392.312 747.262 390.529 748 388.437 748H381.562C379.472 748 377.688 747.262 376.213 745.787C374.738 744.312 374 742.529 374 740.437V733.562C374 731.472 374.738 729.688 376.213 728.213C377.689 726.738 379.472 726 381.562 726H388.437C390.529 726 392.312 726.738 393.787 728.213C395.262 729.689 396 731.472 396 733.562V740.437Z'
        fill={props.color}
      />
      <path
        d='M462 733.562C462 731.471 461.262 729.688 459.787 728.213C458.312 726.738 456.529 726 454.437 726H447.562C445.471 726 443.688 726.738 442.213 728.213C440.738 729.688 440 731.471 440 733.562V740.437C440 740.552 440.014 740.724 440.043 740.953H440V748H462V740.953H461.957C461.986 740.724 462 740.552 462 740.437V733.562Z'
        fill={props.color}
      />
      <path
        d='M506 733.562C506 731.471 505.262 729.688 503.787 728.213C502.312 726.738 500.529 726 498.437 726H491.562C489.471 726 487.688 726.738 486.213 728.213C484.738 729.688 484 731.471 484 733.562V740.437C484 740.552 484.014 740.724 484.043 740.953H484V748H506V740.953H505.957C505.986 740.724 506 740.552 506 740.437V733.562Z'
        fill={props.color}
      />
      <path
        d='M638 733.562C638 731.471 637.262 729.688 635.787 728.213C634.312 726.738 632.529 726 630.437 726H623.562C621.471 726 619.688 726.738 618.213 728.213C616.738 729.688 616 731.471 616 733.562V740.437C616 740.552 616.014 740.724 616.043 740.953H616V748H638V740.953H637.957C637.986 740.724 638 740.552 638 740.437V733.562Z'
        fill={props.color}
      />
      <path
        d='M682 733.562C682 731.471 681.262 729.688 679.787 728.213C678.312 726.738 676.529 726 674.437 726H667.562C665.471 726 663.688 726.738 662.213 728.213C660.738 729.688 660 731.471 660 733.562V740.437C660 740.552 660.014 740.724 660.043 740.953H660V748H682V740.953H681.957C681.986 740.724 682 740.552 682 740.437V733.562Z'
        fill={props.color}
      />
      <path d='M792 726H770V748H792V726Z' fill={props.color} />
      <path d='M814 726H792V748H814V726Z' fill={props.color} />
      <path d='M858 726H836V748H858V726Z' fill={props.color} />
      <path
        d='M924 740.437C924 742.529 923.262 744.312 921.787 745.787C920.312 747.262 918.529 748 916.437 748H909.562C907.472 748 905.688 747.262 904.213 745.787C902.738 744.312 902 742.529 902 740.437V733.562C902 731.472 902.738 729.688 904.213 728.213C905.689 726.738 907.472 726 909.562 726H916.437C918.529 726 920.312 726.738 921.787 728.213C923.262 729.689 924 731.472 924 733.562V740.437Z'
        fill={props.color}
      />
      <path
        d='M65.9571 755.047H66V748H44V755.047H44.0429C44.0143 755.276 44 755.448 44 755.562V762.437C44 764.529 44.7377 766.312 46.213 767.787C47.6883 769.262 49.4714 770 51.5625 770H58.4375C60.5286 770 62.3119 769.262 63.787 767.787C65.2621 766.312 66 764.529 66 762.437V755.562C66 755.448 65.9861 755.276 65.9571 755.047Z'
        fill={props.color}
      />
      <path
        d='M110 762.437C110 764.529 109.262 766.312 107.787 767.787C106.312 769.262 104.529 770 102.437 770H95.5625C93.4716 770 91.6883 769.262 90.2132 767.787C88.7379 766.312 88 764.529 88 762.437V755.562C88 753.472 88.7377 751.688 90.213 750.213C91.6885 748.738 93.4716 748 95.5625 748H102.437C104.529 748 106.312 748.738 107.787 750.213C109.262 751.689 110 753.472 110 755.562V762.437Z'
        fill={props.color}
      />
      <path
        d='M176 755.562V748H161.562C159.471 748 157.688 748.738 156.213 750.213C154.738 751.688 154 753.471 154 755.562V762.437C154 764.529 154.738 766.312 156.213 767.787C157.688 769.262 159.471 770 161.562 770H176V755.562Z'
        fill={props.color}
      />
      <path
        d='M190.437 748H176V770H190.437C192.529 770 194.312 769.262 195.787 767.787C197.262 766.312 198 764.529 198 762.437V755.562C198 753.471 197.262 751.688 195.787 750.213C194.312 748.738 192.529 748 190.437 748Z'
        fill={props.color}
      />
      <path
        d='M286 748H264V762.437C264 764.529 264.738 766.312 266.213 767.787C267.688 769.262 269.471 770 271.562 770H286V748Z'
        fill={props.color}
      />
      <path d='M308 748H286V770H308V748Z' fill={props.color} />
      <path
        d='M322.437 748H308V770H322.437C324.529 770 326.312 769.262 327.787 767.787C329.262 766.312 330 764.529 330 762.437V755.562C330 753.471 329.262 751.688 327.787 750.213C326.312 748.738 324.529 748 322.437 748Z'
        fill={props.color}
      />
      <path
        d='M461.957 755.047H462V748H440V755.047H440.043C440.014 755.276 440 755.448 440 755.562V762.437C440 764.529 440.738 766.312 442.213 767.787C443.688 769.262 445.471 770 447.562 770H454.437C456.529 770 458.312 769.262 459.787 767.787C461.262 766.312 462 764.529 462 762.437V755.562C462 755.448 461.986 755.276 461.957 755.047Z'
        fill={props.color}
      />
      <path d='M506 748H484V770H506V748Z' fill={props.color} />
      <path
        d='M616 755.562V748H601.562C599.471 748 597.688 748.738 596.213 750.213C594.738 751.688 594 753.471 594 755.562V770H616V755.562Z'
        fill={props.color}
      />
      <path d='M638 748H616V770H638V748Z' fill={props.color} />
      <path d='M682 748H660V770H682V748Z' fill={props.color} />
      <path
        d='M696.437 748H682V770H696.437C698.529 770 700.312 769.262 701.787 767.787C703.262 766.312 704 764.529 704 762.437V755.562C704 753.471 703.262 751.688 701.787 750.213C700.312 748.738 698.529 748 696.437 748Z'
        fill={props.color}
      />
      <path
        d='M770 755.562V748H755.562C753.471 748 751.688 748.738 750.213 750.213C748.738 751.688 748 753.471 748 755.562V770H770V755.562Z'
        fill={props.color}
      />
      <path d='M792 748H770V770H792V748Z' fill={props.color} />
      <path d='M814 748H792V770H814V748Z' fill={props.color} />
      <path d='M836 748H814V770H836V748Z' fill={props.color} />
      <path d='M858 748H836V770H858V748Z' fill={props.color} />
      <path d='M880 748H858V770H880V748Z' fill={props.color} />
      <path
        d='M894.437 748H880V770H894.437C896.529 770 898.312 769.262 899.787 767.787C901.262 766.312 902 764.529 902 762.437V755.562C902 753.471 901.262 751.688 899.787 750.213C898.312 748.738 896.529 748 894.437 748Z'
        fill={props.color}
      />
      <path
        d='M242 777.562V770H227.562C225.471 770 223.688 770.738 222.213 772.213C220.738 773.688 220 775.471 220 777.562V784.437C220 786.529 220.738 788.312 222.213 789.787C223.688 791.262 225.471 792 227.562 792H242V777.562Z'
        fill={props.color}
      />
      <path
        d='M264 777.562C264 775.471 263.262 773.688 261.787 772.213C260.312 770.738 258.529 770 256.437 770H242V792H264V777.562Z'
        fill={props.color}
      />
      <path
        d='M307.957 777.047H308V770H286V777.047H286.043C286.014 777.276 286 777.448 286 777.562V784.437C286 786.529 286.738 788.312 288.213 789.787C289.688 791.262 291.471 792 293.562 792H300.437C302.529 792 304.312 791.262 305.787 789.787C307.262 788.312 308 786.529 308 784.437V777.562C308 777.448 307.986 777.276 307.957 777.047Z'
        fill={props.color}
      />
      <path d='M506 770H484V792H506V770Z' fill={props.color} />
      <path d='M528 770H506V792H528V770Z' fill={props.color} />
      <path
        d='M550 777.562C550 775.471 549.262 773.688 547.787 772.213C546.312 770.738 544.529 770 542.437 770H528V792H550V777.562Z'
        fill={props.color}
      />
      <path d='M616 770H594V792H616V770Z' fill={props.color} />
      <path
        d='M638 770H616V792H630.437C632.529 792 634.312 791.262 635.787 789.787C637.262 788.312 638 786.529 638 784.437V770Z'
        fill={props.color}
      />
      <path d='M682 770H660V792H682V770Z' fill={props.color} />
      <path
        d='M726 777.562V770H711.562C709.471 770 707.688 770.738 706.213 772.213C704.738 773.688 704 775.471 704 777.562V792H726V777.562Z'
        fill={props.color}
      />
      <path d='M748 770H726V792H748V770Z' fill={props.color} />
      <path d='M770 770H748V792H770V770Z' fill={props.color} />
      <path d='M858 770H836V792H858V770Z' fill={props.color} />
      <path
        d='M880 770H858V792H872.437C874.529 792 876.312 791.262 877.787 789.787C879.262 788.312 880 786.529 880 784.437V770Z'
        fill={props.color}
      />
      <path
        d='M946 784.437C946 786.529 945.262 788.312 943.787 789.787C942.312 791.262 940.529 792 938.437 792H931.562C929.472 792 927.688 791.262 926.213 789.787C924.738 788.312 924 786.529 924 784.437V777.562C924 775.472 924.738 773.688 926.213 772.213C927.689 770.738 929.472 770 931.562 770H938.437C940.529 770 942.312 770.738 943.787 772.213C945.262 773.689 946 775.472 946 777.562V784.437Z'
        fill={props.color}
      />
      <path d='M264 792H242V814H264V792Z' fill={props.color} />
      <path
        d='M278.437 792H264V814H278.437C280.529 814 282.312 813.262 283.787 811.787C285.262 810.312 286 808.529 286 806.437V799.562C286 797.471 285.262 795.688 283.787 794.213C282.312 792.738 280.529 792 278.437 792Z'
        fill={props.color}
      />
      <path
        d='M330 799.562C330 797.471 329.262 795.688 327.787 794.213C326.312 792.738 324.529 792 322.437 792H315.562C313.471 792 311.688 792.738 310.213 794.213C308.738 795.688 308 797.471 308 799.562V806.437C308 806.552 308.014 806.724 308.043 806.953H308V814H330V806.953H329.957C329.986 806.724 330 806.552 330 806.437V799.562Z'
        fill={props.color}
      />
      <path
        d='M374 799.562V792H359.562C357.471 792 355.688 792.738 354.213 794.213C352.738 795.688 352 797.471 352 799.562V814H374V799.562Z'
        fill={props.color}
      />
      <path
        d='M388.437 792H374V814H388.437C390.529 814 392.312 813.262 393.787 811.787C395.262 810.312 396 808.529 396 806.437V799.562C396 797.471 395.262 795.688 393.787 794.213C392.312 792.738 390.529 792 388.437 792Z'
        fill={props.color}
      />
      <path
        d='M484 799.562V792H469.562C467.471 792 465.688 792.738 464.213 794.213C462.738 795.688 462 797.471 462 799.562V814H484V799.562Z'
        fill={props.color}
      />
      <path d='M506 792H484V814H506V792Z' fill={props.color} />
      <path d='M550 792H528V814H550V792Z' fill={props.color} />
      <path
        d='M594 799.562V792H579.562C577.471 792 575.688 792.738 574.213 794.213C572.738 795.688 572 797.471 572 799.562V806.437C572 808.529 572.738 810.312 574.213 811.787C575.688 813.262 577.471 814 579.562 814H594V799.562Z'
        fill={props.color}
      />
      <path d='M616 792H594V814H616V792Z' fill={props.color} />
      <path
        d='M660 799.562V792H645.562C643.471 792 641.688 792.738 640.213 794.213C638.738 795.688 638 797.471 638 799.562V806.437C638 808.529 638.738 810.312 640.213 811.787C641.688 813.262 643.471 814 645.562 814H660V799.562Z'
        fill={props.color}
      />
      <path
        d='M682 792H660V814H674.437C676.529 814 678.312 813.262 679.787 811.787C681.262 810.312 682 808.529 682 806.437V792Z'
        fill={props.color}
      />
      <path
        d='M726 792H704V806.437C704 808.529 704.738 810.312 706.213 811.787C707.688 813.262 709.471 814 711.562 814H726V792Z'
        fill={props.color}
      />
      <path d='M748 792H726V814H748V792Z' fill={props.color} />
      <path d='M770 792H748V814H770V792Z' fill={props.color} />
      <path
        d='M814 806.437C814 808.529 813.262 810.312 811.787 811.787C810.312 813.262 808.529 814 806.437 814H799.562C797.472 814 795.688 813.262 794.213 811.787C792.738 810.312 792 808.529 792 806.437V799.562C792 797.472 792.738 795.688 794.213 794.213C795.689 792.738 797.472 792 799.562 792H806.437C808.529 792 810.312 792.738 811.787 794.213C813.262 795.689 814 797.472 814 799.562V806.437Z'
        fill={props.color}
      />
      <path d='M858 792H836V814H858V792Z' fill={props.color} />
      <path
        d='M924 806.437C924 808.529 923.262 810.312 921.787 811.787C920.312 813.262 918.529 814 916.437 814H909.562C907.472 814 905.688 813.262 904.213 811.787C902.738 810.312 902 808.529 902 806.437V799.562C902 797.472 902.738 795.688 904.213 794.213C905.689 792.738 907.472 792 909.562 792H916.437C918.529 792 920.312 792.738 921.787 794.213C923.262 795.689 924 797.472 924 799.562V806.437Z'
        fill={props.color}
      />
      <path d='M264 814H242V836H264V814Z' fill={props.color} />
      <path
        d='M308 821.562V814H293.562C291.471 814 289.688 814.738 288.213 816.213C286.738 817.688 286 819.471 286 821.562V828.437C286 830.529 286.738 832.312 288.213 833.787C289.688 835.262 291.471 836 293.562 836H308V821.562Z'
        fill={props.color}
      />
      <path
        d='M330 814H308V836H322.437C324.529 836 326.312 835.262 327.787 833.787C329.262 832.312 330 830.529 330 828.437V814Z'
        fill={props.color}
      />
      <path
        d='M373.957 821.047H374V814H352V821.047H352.043C352.014 821.276 352 821.448 352 821.562V828.437C352 830.529 352.738 832.312 354.213 833.787C355.688 835.262 357.471 836 359.562 836H366.437C368.529 836 370.312 835.262 371.787 833.787C373.262 832.312 374 830.529 374 828.437V821.562C374 821.448 373.986 821.276 373.957 821.047Z'
        fill={props.color}
      />
      <path
        d='M462 821.562V814H447.562C445.471 814 443.688 814.738 442.213 816.213C440.738 817.688 440 819.471 440 821.562V836H462V821.562Z'
        fill={props.color}
      />
      <path d='M484 814H462V836H484V814Z' fill={props.color} />
      <path d='M506 814H484V836H506V814Z' fill={props.color} />
      <path d='M528 814H506V836H528V814Z' fill={props.color} />
      <path d='M550 814H528V836H550V814Z' fill={props.color} />
      <path
        d='M564.437 814H550V836H564.437C566.529 836 568.312 835.262 569.787 833.787C571.262 832.312 572 830.529 572 828.437V821.562C572 819.471 571.262 817.688 569.787 816.213C568.312 814.738 566.529 814 564.437 814Z'
        fill={props.color}
      />
      <path
        d='M616 814H594V828.437C594 830.529 594.738 832.312 596.213 833.787C597.688 835.262 599.471 836 601.562 836H616V814Z'
        fill={props.color}
      />
      <path
        d='M630.437 814H616V836H630.437C632.529 836 634.312 835.262 635.787 833.787C637.262 832.312 638 830.529 638 828.437V821.562C638 819.471 637.262 817.688 635.787 816.213C634.312 814.738 632.529 814 630.437 814Z'
        fill={props.color}
      />
      <path d='M770 814H748V836H770V814Z' fill={props.color} />
      <path d='M858 814H836V836H858V814Z' fill={props.color} />
      <path
        d='M946 821.562C946 819.471 945.262 817.688 943.787 816.213C942.312 814.738 940.529 814 938.437 814H931.562C929.471 814 927.688 814.738 926.213 816.213C924.738 817.688 924 819.471 924 821.562V828.437C924 828.552 924.014 828.724 924.043 828.953H924V836H946V828.953H945.957C945.986 828.724 946 828.552 946 828.437V821.562Z'
        fill={props.color}
      />
      <path
        d='M242 843.562V836H227.562C225.471 836 223.688 836.738 222.213 838.213C220.738 839.688 220 841.471 220 843.562V858H242V843.562Z'
        fill={props.color}
      />
      <path
        d='M264 836H242V858H256.437C258.529 858 260.312 857.262 261.787 855.787C263.262 854.312 264 852.529 264 850.437V836Z'
        fill={props.color}
      />
      <path
        d='M352 843.562C352 841.471 351.262 839.688 349.787 838.213C348.312 836.738 346.529 836 344.437 836H337.562C335.471 836 333.688 836.738 332.213 838.213C330.738 839.688 330 841.471 330 843.562V850.437C330 850.552 330.014 850.724 330.043 850.953H330V858H352V850.953H351.957C351.986 850.724 352 850.552 352 850.437V843.562Z'
        fill={props.color}
      />
      <path
        d='M396 843.562C396 841.471 395.262 839.688 393.787 838.213C392.312 836.738 390.529 836 388.437 836H381.562C379.471 836 377.688 836.738 376.213 838.213C374.738 839.688 374 841.471 374 843.562V850.437C374 850.552 374.014 850.724 374.043 850.953H374V858H396V850.953H395.957C395.986 850.724 396 850.552 396 850.437V843.562Z'
        fill={props.color}
      />
      <path d='M462 836H440V858H462V836Z' fill={props.color} />
      <path
        d='M549.957 843.047H550V836H528V843.047H528.043C528.014 843.276 528 843.448 528 843.562V850.437C528 852.529 528.738 854.312 530.213 855.787C531.688 857.262 533.471 858 535.562 858H542.437C544.529 858 546.312 857.262 547.787 855.787C549.262 854.312 550 852.529 550 850.437V843.562C550 843.448 549.986 843.276 549.957 843.047Z'
        fill={props.color}
      />
      <path
        d='M660 850.437C660 852.529 659.262 854.312 657.787 855.787C656.312 857.262 654.529 858 652.437 858H645.562C643.472 858 641.688 857.262 640.213 855.787C638.738 854.312 638 852.529 638 850.437V843.562C638 841.472 638.738 839.688 640.213 838.213C641.689 836.738 643.472 836 645.562 836H652.437C654.529 836 656.312 836.738 657.787 838.213C659.262 839.689 660 841.472 660 843.562V850.437Z'
        fill={props.color}
      />
      <path
        d='M726 850.437C726 852.529 725.262 854.312 723.787 855.787C722.312 857.262 720.529 858 718.437 858H711.562C709.472 858 707.688 857.262 706.213 855.787C704.738 854.312 704 852.529 704 850.437V843.562C704 841.472 704.738 839.688 706.213 838.213C707.689 836.738 709.472 836 711.562 836H718.437C720.529 836 722.312 836.738 723.787 838.213C725.262 839.689 726 841.472 726 843.562V850.437Z'
        fill={props.color}
      />
      <path
        d='M770 836H748V850.437C748 852.529 748.738 854.312 750.213 855.787C751.688 857.262 753.471 858 755.562 858H770V836Z'
        fill={props.color}
      />
      <path d='M792 836H770V858H792V836Z' fill={props.color} />
      <path d='M814 836H792V858H814V836Z' fill={props.color} />
      <path d='M836 836H814V858H836V836Z' fill={props.color} />
      <path d='M858 836H836V858H858V836Z' fill={props.color} />
      <path d='M880 836H858V858H880V836Z' fill={props.color} />
      <path
        d='M894.437 836H880V858H894.437C896.529 858 898.312 857.262 899.787 855.787C901.262 854.312 902 852.529 902 850.437V843.562C902 841.471 901.262 839.688 899.787 838.213C898.312 836.738 896.529 836 894.437 836Z'
        fill={props.color}
      />
      <path d='M946 836H924V858H946V836Z' fill={props.color} />
      <path d='M242 858H220V880H242V858Z' fill={props.color} />
      <path
        d='M308 872.437C308 874.529 307.262 876.312 305.787 877.787C304.312 879.262 302.529 880 300.437 880H293.562C291.472 880 289.688 879.262 288.213 877.787C286.738 876.312 286 874.529 286 872.437V865.562C286 863.472 286.738 861.688 288.213 860.213C289.689 858.738 291.472 858 293.562 858H300.437C302.529 858 304.312 858.738 305.787 860.213C307.262 861.689 308 863.472 308 865.562V872.437Z'
        fill={props.color}
      />
      <path
        d='M351.957 865.047H352V858H330V865.047H330.043C330.014 865.276 330 865.448 330 865.562V872.437C330 874.529 330.738 876.312 332.213 877.787C333.688 879.262 335.471 880 337.562 880H344.437C346.529 880 348.312 879.262 349.787 877.787C351.262 876.312 352 874.529 352 872.437V865.562C352 865.448 351.986 865.276 351.957 865.047Z'
        fill={props.color}
      />
      <path
        d='M395.957 865.047H396V858H374V865.047H374.043C374.014 865.276 374 865.448 374 865.562V872.437C374 874.529 374.738 876.312 376.213 877.787C377.688 879.262 379.471 880 381.562 880H388.437C390.529 880 392.312 879.262 393.787 877.787C395.262 876.312 396 874.529 396 872.437V865.562C396 865.448 395.986 865.276 395.957 865.047Z'
        fill={props.color}
      />
      <path
        d='M462 858H440V872.437C440 874.529 440.738 876.312 442.213 877.787C443.688 879.262 445.471 880 447.562 880H462V858Z'
        fill={props.color}
      />
      <path d='M484 858H462V880H484V858Z' fill={props.color} />
      <path d='M506 858H484V880H506V858Z' fill={props.color} />
      <path
        d='M528 865.562C528 863.471 527.262 861.688 525.787 860.213C524.312 858.738 522.529 858 520.437 858H506V880H528V865.562Z'
        fill={props.color}
      />
      <path
        d='M616 865.562V858H601.562C599.471 858 597.688 858.738 596.213 860.213C594.738 861.688 594 863.471 594 865.562V872.437C594 874.529 594.738 876.312 596.213 877.787C597.688 879.262 599.471 880 601.562 880H616V865.562Z'
        fill={props.color}
      />
      <path
        d='M638 865.562C638 863.471 637.262 861.688 635.787 860.213C634.312 858.738 632.529 858 630.437 858H616V880H638V865.562Z'
        fill={props.color}
      />
      <path
        d='M704 865.562C704 863.471 703.262 861.688 701.787 860.213C700.312 858.738 698.529 858 696.437 858H689.562C687.471 858 685.688 858.738 684.213 860.213C682.738 861.688 682 863.471 682 865.562V872.437C682 872.552 682.014 872.724 682.043 872.953H682V880H704V872.953H703.957C703.986 872.724 704 872.552 704 872.437V865.562Z'
        fill={props.color}
      />
      <path
        d='M748 865.562C748 863.471 747.262 861.688 745.787 860.213C744.312 858.738 742.529 858 740.437 858H733.562C731.471 858 729.688 858.738 728.213 860.213C726.738 861.688 726 863.471 726 865.562V872.437C726 872.552 726.014 872.724 726.043 872.953H726V880H748V872.953H747.957C747.986 872.724 748 872.552 748 872.437V865.562Z'
        fill={props.color}
      />
      <path d='M792 858H770V880H792V858Z' fill={props.color} />
      <path d='M836 858H814V880H836V858Z' fill={props.color} />
      <path
        d='M924 865.562V858H909.562C907.471 858 905.688 858.738 904.213 860.213C902.738 861.688 902 863.471 902 865.562V880H924V865.562Z'
        fill={props.color}
      />
      <path
        d='M946 858H924V880H938.437C940.529 880 942.312 879.262 943.787 877.787C945.262 876.312 946 874.529 946 872.437V858Z'
        fill={props.color}
      />
      <path
        d='M241.957 887.047H242V880H220V887.047H220.043C220.014 887.276 220 887.448 220 887.562V894.437C220 896.529 220.738 898.312 222.213 899.787C223.688 901.262 225.471 902 227.562 902H234.437C236.529 902 238.312 901.262 239.787 899.787C241.262 898.312 242 896.529 242 894.437V887.562C242 887.448 241.986 887.276 241.957 887.047Z'
        fill={props.color}
      />
      <path
        d='M286 887.562C286 885.471 285.262 883.688 283.787 882.213C282.312 880.738 280.529 880 278.437 880H271.562C269.471 880 267.688 880.738 266.213 882.213C264.738 883.688 264 885.471 264 887.562V894.437C264 894.552 264.014 894.724 264.043 894.953H264V902H286V894.953H285.957C285.986 894.724 286 894.552 286 894.437V887.562Z'
        fill={props.color}
      />
      <path
        d='M330 887.562C330 885.471 329.262 883.688 327.787 882.213C326.312 880.738 324.529 880 322.437 880H315.562C313.471 880 311.688 880.738 310.213 882.213C308.738 883.688 308 885.471 308 887.562V894.437C308 894.552 308.014 894.724 308.043 894.953H308V902H330V894.953H329.957C329.986 894.724 330 894.552 330 894.437V887.562Z'
        fill={props.color}
      />
      <path
        d='M506 880H484V894.437C484 896.529 484.738 898.312 486.213 899.787C487.688 901.262 489.471 902 491.562 902H506V880Z'
        fill={props.color}
      />
      <path d='M528 880H506V902H528V880Z' fill={props.color} />
      <path
        d='M550 887.562C550 885.471 549.262 883.688 547.787 882.213C546.312 880.738 544.529 880 542.437 880H528V902H550V887.562Z'
        fill={props.color}
      />
      <path
        d='M638 880H616V894.437C616 896.529 616.738 898.312 618.213 899.787C619.688 901.262 621.471 902 623.562 902H638V880Z'
        fill={props.color}
      />
      <path
        d='M660 887.562C660 885.471 659.262 883.688 657.787 882.213C656.312 880.738 654.529 880 652.437 880H638V902H660V887.562Z'
        fill={props.color}
      />
      <path
        d='M703.957 887.047H704V880H682V887.047H682.043C682.014 887.276 682 887.448 682 887.562V894.437C682 896.529 682.738 898.312 684.213 899.787C685.688 901.262 687.471 902 689.562 902H696.437C698.529 902 700.312 901.262 701.787 899.787C703.262 898.312 704 896.529 704 894.437V887.562C704 887.448 703.986 887.276 703.957 887.047Z'
        fill={props.color}
      />
      <path d='M748 880H726V902H748V880Z' fill={props.color} />
      <path
        d='M792 880H770V894.437C770 896.529 770.738 898.312 772.213 899.787C773.688 901.262 775.471 902 777.562 902H792V880Z'
        fill={props.color}
      />
      <path d='M814 880H792V902H814V880Z' fill={props.color} />
      <path d='M836 880H814V902H836V880Z' fill={props.color} />
      <path d='M858 880H836V902H858V880Z' fill={props.color} />
      <path
        d='M872.437 880H858V902H872.437C874.529 902 876.312 901.262 877.787 899.787C879.262 898.312 880 896.529 880 894.437V887.562C880 885.471 879.262 883.688 877.787 882.213C876.312 880.738 874.529 880 872.437 880Z'
        fill={props.color}
      />
      <path d='M924 880H902V902H924V880Z' fill={props.color} />
      <path
        d='M264 909.562V902H249.562C247.471 902 245.688 902.738 244.213 904.213C242.738 905.688 242 907.471 242 909.562V916.437C242 918.529 242.738 920.312 244.213 921.787C245.688 923.262 247.471 924 249.562 924H264V909.562Z'
        fill={props.color}
      />
      <path
        d='M286 902H264V924H278.437C280.529 924 282.312 923.262 283.787 921.787C285.262 920.312 286 918.529 286 916.437V902Z'
        fill={props.color}
      />
      <path d='M330 902H308V924H330V902Z' fill={props.color} />
      <path
        d='M344.437 902H330V924H344.437C346.529 924 348.312 923.262 349.787 921.787C351.262 920.312 352 918.529 352 916.437V909.562C352 907.471 351.262 905.688 349.787 904.213C348.312 902.738 346.529 902 344.437 902Z'
        fill={props.color}
      />
      <path
        d='M396 909.562C396 907.471 395.262 905.688 393.787 904.213C392.312 902.738 390.529 902 388.437 902H381.562C379.471 902 377.688 902.738 376.213 904.213C374.738 905.688 374 907.471 374 909.562V916.437C374 916.552 374.014 916.724 374.043 916.953H374V924H396V916.953H395.957C395.986 916.724 396 916.552 396 916.437V909.562Z'
        fill={props.color}
      />
      <path d='M528 902H506V924H528V902Z' fill={props.color} />
      <path d='M550 902H528V924H550V902Z' fill={props.color} />
      <path d='M572 902H550V924H572V902Z' fill={props.color} />
      <path
        d='M594 909.562C594 907.471 593.262 905.688 591.787 904.213C590.312 902.738 588.529 902 586.437 902H572V924H594V909.562Z'
        fill={props.color}
      />
      <path d='M660 902H638V924H660V902Z' fill={props.color} />
      <path
        d='M726 909.562V902H711.562C709.471 902 707.688 902.738 706.213 904.213C704.738 905.688 704 907.471 704 909.562V916.437C704 918.529 704.738 920.312 706.213 921.787C707.688 923.262 709.471 924 711.562 924H726V909.562Z'
        fill={props.color}
      />
      <path d='M748 902H726V924H748V902Z' fill={props.color} />
      <path
        d='M762.437 902H748V924H762.437C764.529 924 766.312 923.262 767.787 921.787C769.262 920.312 770 918.529 770 916.437V909.562C770 907.471 769.262 905.688 767.787 904.213C766.312 902.738 764.529 902 762.437 902Z'
        fill={props.color}
      />
      <path d='M858 902H836V924H858V902Z' fill={props.color} />
      <path
        d='M923.957 909.047H924V902H902V909.047H902.043C902.014 909.276 902 909.448 902 909.562V916.437C902 918.529 902.738 920.312 904.213 921.787C905.688 923.262 907.471 924 909.562 924H916.437C918.529 924 920.312 923.262 921.787 921.787C923.262 920.312 924 918.529 924 916.437V909.562C924 909.448 923.986 909.276 923.957 909.047Z'
        fill={props.color}
      />
      <path
        d='M308 931.562V924H293.562C291.471 924 289.688 924.738 288.213 926.213C286.738 927.688 286 929.471 286 931.562V938.437C286 940.529 286.738 942.312 288.213 943.787C289.688 945.262 291.471 946 293.562 946H308V931.562Z'
        fill={props.color}
      />
      <path
        d='M330 924H308V946H322.437C324.529 946 326.312 945.262 327.787 943.787C329.262 942.312 330 940.529 330 938.437V924Z'
        fill={props.color}
      />
      <path
        d='M395.957 931.047H396V924H374V931.047H374.043C374.014 931.276 374 931.448 374 931.562V938.437C374 940.529 374.738 942.312 376.213 943.787C377.688 945.262 379.471 946 381.562 946H388.437C390.529 946 392.312 945.262 393.787 943.787C395.262 942.312 396 940.529 396 938.437V931.562C396 931.448 395.986 931.276 395.957 931.047Z'
        fill={props.color}
      />
      <path
        d='M440 931.562V924H425.562C423.471 924 421.688 924.738 420.213 926.213C418.738 927.688 418 929.471 418 931.562V938.437C418 940.529 418.738 942.312 420.213 943.787C421.688 945.262 423.471 946 425.562 946H440V931.562Z'
        fill={props.color}
      />
      <path
        d='M454.437 924H440V946H454.437C456.529 946 458.312 945.262 459.787 943.787C461.262 942.312 462 940.529 462 938.437V931.562C462 929.471 461.262 927.688 459.787 926.213C458.312 924.738 456.529 924 454.437 924Z'
        fill={props.color}
      />
      <path
        d='M506 931.562V924H491.562C489.471 924 487.688 924.738 486.213 926.213C484.738 927.688 484 929.471 484 931.562V938.437C484 940.529 484.738 942.312 486.213 943.787C487.688 945.262 489.471 946 491.562 946H506V931.562Z'
        fill={props.color}
      />
      <path
        d='M528 924H506V946H520.437C522.529 946 524.312 945.262 525.787 943.787C527.262 942.312 528 940.529 528 938.437V924Z'
        fill={props.color}
      />
      <path
        d='M572 924H550V938.437C550 940.529 550.738 942.312 552.213 943.787C553.688 945.262 555.471 946 557.562 946H572V924Z'
        fill={props.color}
      />
      <path d='M594 924H572V946H594V924Z' fill={props.color} />
      <path
        d='M608.437 924H594V946H608.437C610.529 946 612.312 945.262 613.787 943.787C615.262 942.312 616 940.529 616 938.437V931.562C616 929.471 615.262 927.688 613.787 926.213C612.312 924.738 610.529 924 608.437 924Z'
        fill={props.color}
      />
      <path
        d='M659.957 931.047H660V924H638V931.047H638.043C638.014 931.276 638 931.448 638 931.562V938.437C638 940.529 638.738 942.312 640.213 943.787C641.688 945.262 643.471 946 645.562 946H652.437C654.529 946 656.312 945.262 657.787 943.787C659.262 942.312 660 940.529 660 938.437V931.562C660 931.448 659.986 931.276 659.957 931.047Z'
        fill={props.color}
      />
      <path
        d='M704 938.437C704 940.529 703.262 942.312 701.787 943.787C700.312 945.262 698.529 946 696.437 946H689.562C687.472 946 685.688 945.262 684.213 943.787C682.738 942.312 682 940.529 682 938.437V931.562C682 929.472 682.738 927.688 684.213 926.213C685.689 924.738 687.472 924 689.562 924H696.437C698.529 924 700.312 924.738 701.787 926.213C703.262 927.689 704 929.472 704 931.562V938.437Z'
        fill={props.color}
      />
      <path
        d='M836 931.562V924H821.562C819.471 924 817.688 924.738 816.213 926.213C814.738 927.688 814 929.471 814 931.562V938.437C814 940.529 814.738 942.312 816.213 943.787C817.688 945.262 819.471 946 821.562 946H836V931.562Z'
        fill={props.color}
      />
      <path d='M858 924H836V946H858V924Z' fill={props.color} />
      <path
        d='M872.437 924H858V946H872.437C874.529 946 876.312 945.262 877.787 943.787C879.262 942.312 880 940.529 880 938.437V931.562C880 929.471 879.262 927.688 877.787 926.213C876.312 924.738 874.529 924 872.437 924Z'
        fill={props.color}
      />
      <path
        d='M145.423 44.0123H96.5771C72.7718 44.0123 52.604 59.7404 46.156 81.2372C45.4892 83.461 44.9687 85.7463 44.6068 88.0825C44.2079 90.6605 44 93.3 44 95.9873V145.993C44 174.666 67.5928 197.983 96.5771 197.983L121 197.988L145.423 197.982C174.406 197.982 198 174.664 198 145.991V95.9873C198 67.3279 174.407 44.0123 145.423 44.0123ZM174.9 145.993C174.9 161.922 161.678 174.883 145.417 174.883L121 174.888L96.5833 174.882C80.3224 174.882 67.1 161.921 67.1 145.993V95.9873C67.1 91.0116 68.3905 86.3269 70.662 82.2336C72.8488 78.2958 75.9427 74.9094 79.6679 72.3453C84.4573 69.0481 90.2893 67.1123 96.5756 67.1123H145.423C161.678 67.1123 174.9 80.0653 174.9 95.9873V145.993Z'
        fill={props.color}
      />
      <path
        d='M893.423 44.0123H844.577C820.772 44.0123 800.604 59.7404 794.156 81.2372C793.489 83.461 792.969 85.7463 792.607 88.0825C792.208 90.6605 792 93.3 792 95.9873V145.993C792 174.666 815.593 197.983 844.577 197.983L869 197.988L893.423 197.982C922.406 197.982 946 174.664 946 145.991V95.9873C946 67.3279 922.407 44.0123 893.423 44.0123ZM922.9 145.993C922.9 161.922 909.678 174.883 893.417 174.883L869 174.888L844.583 174.882C828.322 174.882 815.1 161.921 815.1 145.993V95.9873C815.1 91.0116 816.391 86.3269 818.662 82.2336C820.849 78.2958 823.943 74.9094 827.668 72.3453C832.457 69.0481 838.289 67.1123 844.576 67.1123H893.423C909.678 67.1123 922.9 80.0653 922.9 95.9873V145.993Z'
        fill={props.color}
      />
      <path
        d='M145.423 792.012H96.5771C72.7718 792.012 52.604 807.74 46.156 829.237C45.4892 831.461 44.9687 833.746 44.6068 836.083C44.2079 838.66 44 841.3 44 843.987V893.993C44 922.666 67.5928 945.983 96.5771 945.983L121 945.988L145.423 945.982C174.406 945.982 198 922.664 198 893.991V843.987C198 815.328 174.407 792.012 145.423 792.012ZM174.9 893.993C174.9 909.922 161.678 922.883 145.417 922.883L121 922.888L96.5833 922.882C80.3224 922.882 67.1 909.921 67.1 893.993V843.987C67.1 839.012 68.3905 834.327 70.662 830.234C72.8488 826.296 75.9427 822.909 79.6679 820.345C84.4573 817.048 90.2893 815.112 96.5756 815.112H145.423C161.678 815.112 174.9 828.065 174.9 843.987V893.993Z'
        fill={props.color}
      />
      <path
        d='M106.052 154C96.0923 154 87.9908 146.059 87.9908 136.307V105.684C87.9908 102.637 88.7828 99.7704 90.1694 97.2618C91.5086 94.8475 93.4041 92.7725 95.687 91.2069C98.6194 89.1887 102.194 88 106.042 88H135.958C145.908 88 154.009 95.9319 154.009 105.683V136.306C154.009 146.058 145.908 153.999 135.958 153.999H121H106.052V154Z'
        fill={props.color}
      />
      <path
        d='M854.052 154C844.092 154 835.991 146.059 835.991 136.307V105.684C835.991 102.637 836.783 99.7704 838.169 97.2618C839.509 94.8475 841.404 92.7725 843.687 91.2069C846.619 89.1887 850.194 88 854.042 88H883.958C893.908 88 902.009 95.9319 902.009 105.683V136.306C902.009 146.058 893.908 153.999 883.958 153.999H869H854.052V154Z'
        fill={props.color}
      />
      <path
        d='M106.052 902C96.0923 902 87.9908 894.059 87.9908 884.307V853.684C87.9908 850.637 88.7828 847.77 90.1694 845.262C91.5086 842.848 93.4041 840.772 95.687 839.207C98.6194 837.189 102.194 836 106.042 836H135.958C145.908 836 154.009 843.932 154.009 853.683V884.306C154.009 894.058 145.908 901.999 135.958 901.999H121H106.052V902Z'
        fill={props.color}
      />
      <g clipPath='url(#clip0_51:558)'>
        <path
          d='M352 494.999C352 416.022 416.025 352 495.001 352C573.978 352 638 416.022 638 494.999C638 573.978 573.978 638 495.001 638C416.025 638 352 573.978 352 494.999'
          fill={props.logoBackground}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M496.896 415C453.815 415 418.887 449.926 418.887 493.014C418.887 507.754 422.979 521.537 430.083 533.299L416 575.151L459.19 561.326C470.37 567.505 483.222 571.028 496.896 571.028C539.989 571.028 574.918 536.097 574.918 493.014C574.918 449.926 539.989 415 496.896 415V415ZM496.896 557.96C483.713 557.96 471.424 554.003 461.172 547.217L436.212 555.208L444.325 531.09C436.551 520.384 431.961 507.23 431.961 493.014C431.961 457.196 461.091 428.066 496.896 428.066C532.711 428.066 561.844 457.196 561.844 493.014C561.844 528.821 532.711 557.96 496.896 557.96V557.96ZM533.477 510.74C531.524 509.668 521.916 504.484 520.117 503.753C518.317 503.018 516.998 502.64 515.592 504.583C514.197 506.521 510.204 510.865 509.002 512.148C507.787 513.439 506.621 513.559 504.662 512.485C502.714 511.416 496.372 509.071 489.02 502.001C483.298 496.503 479.548 489.835 478.46 487.798C477.368 485.761 478.452 484.723 479.485 483.769C480.416 482.906 481.566 481.513 482.607 480.389C483.64 479.267 484.005 478.446 484.719 477.145C485.431 475.843 485.144 474.667 484.68 473.653C484.221 472.638 480.607 462.689 479.099 458.639C477.587 454.594 475.905 455.194 474.744 455.147C473.581 455.108 472.261 454.891 470.934 454.839C469.601 454.792 467.426 455.209 465.533 457.131C463.629 459.053 458.301 463.68 457.938 473.48C457.568 483.276 464.349 493.014 465.295 494.375C466.242 495.744 478.241 516.984 498.179 525.715C518.13 534.452 518.237 531.789 521.893 531.593C525.557 531.398 533.856 527.212 535.692 522.627C537.528 518.042 537.674 514.055 537.209 513.207C536.74 512.357 535.431 511.809 533.477 510.74'
          fill={props.logoColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_51:558'>
          <rect
            width='286'
            height='286'
            fill={props.background}
            transform='translate(352 352)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

QRCodeWhatsapp.defaultProps = {
  background: 'white',
  color: '#3fa110',
  logoBackground: '#3fa110',
  logoColor: 'white'
}
